var $a0b4f895e1596b3b$exports = {};
!function(n) {
    "use strict";
    function r(n, r, e) {
        return e.a = n, e.f = r, e;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(e) {
                return n(r, e);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(e) {
                return function(t) {
                    return n(r, e, t);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(e) {
                return function(t) {
                    return function(u) {
                        return n(r, e, t, u);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(e) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return n(r, e, t, u, a);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return r(6, n, function(r) {
            return function(e) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return n(r, e, t, u, a, i);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(n) {
        return r(7, n, function(r) {
            return function(e) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return n(r, e, t, u, a, i, o);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, e) {
        return 2 === n.a ? n.f(r, e) : n(r)(e);
    }
    function A3(n, r, e, t) {
        return 3 === n.a ? n.f(r, e, t) : n(r)(e)(t);
    }
    function A4(n, r, e, t, u) {
        return 4 === n.a ? n.f(r, e, t, u) : n(r)(e)(t)(u);
    }
    function A5(n, r, e, t, u, a) {
        return 5 === n.a ? n.f(r, e, t, u, a) : n(r)(e)(t)(u)(a);
    }
    function A6(n, r, e, t, u, a, i) {
        return 6 === n.a ? n.f(r, e, t, u, a, i) : n(r)(e)(t)(u)(a)(i);
    }
    function A7(n, r, e, t, u, a, i, o) {
        return 7 === n.a ? n.f(r, e, t, u, a, i, o) : n(r)(e)(t)(u)(a)(i)(o);
    }
    function e(n, r) {
        for(var e, u = [], a = t(n, r, 0, u); a && (e = u.pop()); a = t(e.a, e.b, 0, u));
        return a;
    }
    function t(n, r, e, u) {
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && m(5), !1;
        if (e > 100) return u.push(i(n, r)), !0;
        for(var a in 0 > n.$ && (n = Fe(n), r = Fe(r)), n)if (!t(n[a], r[a], e + 1, u)) return !1;
        return !0;
    }
    function u(n, r, e) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (e = u(n.a, r.a)) || (e = u(n.b, r.b)) ? e : u(n.c, r.c);
        for(; n.b && r.b && !(e = u(n.a, r.a)); n = n.b, r = r.b);
        return e || (n.b ? 1 : r.b ? -1 : 0);
    }
    var a = F2(function(n, r) {
        var e = u(n, r);
        return 0 > e ? ye : e ? Ee : Te;
    });
    function i(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function o(n, r, e) {
        return {
            a: n,
            b: r,
            c: e
        };
    }
    function c(n, r) {
        var e = {};
        for(var t in n)e[t] = n[t];
        for(var t in r)e[t] = r[t];
        return e;
    }
    function f(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var e = b(n.a, r);
        n = n.b;
        for(var t = e; n.b; n = n.b)t = t.b = b(n.a, r);
        return e;
    }
    var s = {
        $: 0
    };
    function b(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var l = F2(b);
    function v(n) {
        for(var r = s, e = n.length; e--;)r = b(n[e], r);
        return r;
    }
    var d = F2(function(n, r) {
        return v((function(n) {
            for(var r = []; n.b; n = n.b)r.push(n.a);
            return r;
        })(r).sort(function(r, e) {
            var t = A2(n, r, e);
            return t === Te ? 0 : t === ye ? -1 : 1;
        }));
    }), g = F3(function(n, r, e) {
        for(var t = Array(n), u = 0; n > u; u++)t[u] = e(r + u);
        return t;
    }), h = F2(function(n, r) {
        for(var e = Array(n), t = 0; n > t && r.b; t++)e[t] = r.a, r = r.b;
        return e.length = t, i(e, r);
    });
    function m(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    var p = Math.PI, $ = Math.cos, A = Math.sin, T = Math.ceil, E = Math.floor, y = Math.round, w = Math.sqrt, _ = Math.log, F = F2(function(n, r) {
        return n + r;
    });
    function S(n) {
        return {
            $: 2,
            b: n
        };
    }
    var R = S(function(n) {
        return "number" != typeof n ? H("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? Ne(n) : !isFinite(n) || n % 1 ? H("an INT", n) : Ne(n);
    }), L = S(function(n) {
        return "boolean" == typeof n ? Ne(n) : H("a BOOL", n);
    }), D = S(function(n) {
        return "number" == typeof n ? Ne(n) : H("a FLOAT", n);
    }), N = S(function(n) {
        return Ne(n);
    }), O = S(function(n) {
        return "string" == typeof n ? Ne(n) : n instanceof String ? Ne(n + "") : H("a STRING", n);
    }), k = F2(function(n, r) {
        return {
            $: 6,
            d: n,
            b: r
        };
    }), C = F2(function(n, r) {
        return {
            $: 7,
            e: n,
            b: r
        };
    });
    function M(n, r) {
        return {
            $: 9,
            f: n,
            g: r
        };
    }
    var I = F2(function(n, r) {
        return {
            $: 10,
            b: r,
            h: n
        };
    }), P = F2(function(n, r) {
        return M(n, [
            r
        ]);
    }), B = F3(function(n, r, e) {
        return M(n, [
            r,
            e
        ]);
    }), x = F4(function(n, r, e, t) {
        return M(n, [
            r,
            e,
            t
        ]);
    }), j = F5(function(n, r, e, t, u) {
        return M(n, [
            r,
            e,
            t,
            u
        ]);
    }), V = F7(function(n, r, e, t, u, a, i) {
        return M(n, [
            r,
            e,
            t,
            u,
            a,
            i
        ]);
    }), U = F2(function(n, r) {
        try {
            return Y(n, JSON.parse(r));
        } catch (n) {
            return Se(A2(Re, "This is not valid JSON! " + n.message, r));
        }
    }), z = F2(function(n, r) {
        return Y(n, r);
    });
    function Y(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? Ne(n.c) : H("null", r);
            case 3:
                return q(r) ? K(n.b, r, v) : H("a LIST", r);
            case 4:
                return q(r) ? K(n.b, r, W) : H("an ARRAY", r);
            case 6:
                var e = n.d;
                if ("object" != typeof r || null === r || !(e in r)) return H("an OBJECT with a field named `" + e + "`", r);
                var t = Y(n.b, r[e]);
                return at(t) ? t : Se(A2(Le, e, t.a));
            case 7:
                var u = n.e;
                return q(r) ? r.length > u ? (t = Y(n.b, r[u]), at(t) ? t : Se(A2(De, u, t.a))) : H("a LONGER array. Need index " + u + " but only see " + r.length + " entries", r) : H("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || q(r)) return H("an OBJECT", r);
                var a = s;
                for(var o in r)if (r.hasOwnProperty(o)) {
                    if (t = Y(n.b, r[o]), !at(t)) return Se(A2(Le, o, t.a));
                    a = b(i(o, t.a), a);
                }
                return Ne(xe(a));
            case 9:
                for(var c = n.f, f = n.g, l = 0; f.length > l; l++){
                    if (t = Y(f[l], r), !at(t)) return t;
                    c = c(t.a);
                }
                return Ne(c);
            case 10:
                return t = Y(n.b, r), at(t) ? Y(n.h(t.a), r) : t;
            case 11:
                for(var d = s, g = n.g; g.b; g = g.b){
                    if (t = Y(g.a, r), at(t)) return t;
                    d = b(t.a, d);
                }
                return Se(Oe(xe(d)));
            case 1:
                return Se(A2(Re, n.a, r));
            case 0:
                return Ne(n.a);
        }
    }
    function K(n, r, e) {
        for(var t = r.length, u = Array(t), a = 0; t > a; a++){
            var i = Y(n, r[a]);
            if (!at(i)) return Se(A2(De, a, i.a));
            u[a] = i.a;
        }
        return Ne(e(u));
    }
    function q(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function W(n) {
        return A2(ut, n.length, function(r) {
            return n[r];
        });
    }
    function H(n, r) {
        return Se(A2(Re, "Expecting " + n, r));
    }
    function G(n, r) {
        if (n === r) return !0;
        if (n.$ !== r.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === r.a;
            case 2:
                return n.b === r.b;
            case 5:
                return n.c === r.c;
            case 3:
            case 4:
            case 8:
                return G(n.b, r.b);
            case 6:
                return n.d === r.d && G(n.b, r.b);
            case 7:
                return n.e === r.e && G(n.b, r.b);
            case 9:
                return n.f === r.f && X(n.g, r.g);
            case 10:
                return n.h === r.h && G(n.b, r.b);
            case 11:
                return X(n.g, r.g);
        }
    }
    function X(n, r) {
        var e = n.length;
        if (e !== r.length) return !1;
        for(var t = 0; e > t; t++)if (!G(n[t], r[t])) return !1;
        return !0;
    }
    function J(n) {
        return n;
    }
    function Q(n) {
        return {
            $: 0,
            a: n
        };
    }
    function Z(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var nn = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), rn = F2(function(n, r) {
        return {
            $: 4,
            b: n,
            d: r
        };
    }), en = 0;
    function tn(n) {
        var r = {
            $: 0,
            e: en++,
            f: n,
            g: null,
            h: []
        };
        return sn(r), r;
    }
    function un(n) {
        return Z(function(r) {
            r(Q(tn(n)));
        });
    }
    function an(n, r) {
        n.h.push(r), sn(n);
    }
    var on = F2(function(n, r) {
        return Z(function(e) {
            an(n, r), e(Q(0));
        });
    }), cn = !1, fn = [];
    function sn(n) {
        if (fn.push(n), !cn) {
            for(cn = !0; n = fn.shift();)bn(n);
            cn = !1;
        }
    }
    function bn(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, sn(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    var ln = {};
    function vn(n, r, e, t, u) {
        return {
            b: n,
            c: r,
            d: e,
            e: t,
            f: u
        };
    }
    function dn(n, r) {
        var e = {
            g: r,
            h: void 0
        }, t = n.c, u = n.d, a = n.e, i = n.f;
        function o(n) {
            return A2(nn, o, {
                $: 5,
                b: function(r) {
                    var o = r.a;
                    return 0 === r.$ ? A3(u, e, o, n) : a && i ? A4(t, e, o.i, o.j, n) : A3(t, e, a ? o.i : o.j, n);
                }
            });
        }
        return e.h = tn(A2(nn, o, n.b));
    }
    var gn = F2(function(n, r) {
        return Z(function(e) {
            n.g(r), e(Q(0));
        });
    }), hn = F2(function(n, r) {
        return A2(on, n.h, {
            $: 0,
            a: r
        });
    });
    function mn(n) {
        return function(r) {
            return {
                $: 1,
                k: n,
                l: r
            };
        };
    }
    function pn(n) {
        return {
            $: 2,
            m: n
        };
    }
    var $n = F2(function(n, r) {
        return {
            $: 3,
            n: n,
            o: r
        };
    }), An = [], Tn = !1;
    function En(n, r, e) {
        if (An.push({
            p: n,
            q: r,
            r: e
        }), !Tn) {
            Tn = !0;
            for(var t; t = An.shift();)yn(t.p, t.q, t.r);
            Tn = !1;
        }
    }
    function yn(n, r, e) {
        var t = {};
        for(var u in wn(!0, r, t, null), wn(!1, e, t, null), n)an(n[u], {
            $: "fx",
            a: t[u] || {
                i: s,
                j: s
            }
        });
    }
    function wn(n, r, e, t) {
        switch(r.$){
            case 1:
                var u = r.k, a = function(n, r, e, t) {
                    function u(n) {
                        for(var r = e; r; r = r.t)n = r.s(n);
                        return n;
                    }
                    return A2(n ? ln[r].e : ln[r].f, u, t);
                }(n, u, t, r.l);
                return void (e[u] = function(n, r, e) {
                    return e = e || {
                        i: s,
                        j: s
                    }, n ? e.i = b(r, e.i) : e.j = b(r, e.j), e;
                }(n, a, e[u]));
            case 2:
                for(var i = r.m; i.b; i = i.b)wn(n, i.a, e, t);
                return;
            case 3:
                return void wn(n, r.o, e, {
                    s: r.n,
                    t: t
                });
        }
    }
    function _n(n, r) {
        return function(n) {
            ln[n] && m(3);
        }(n), ln[n] = {
            f: Fn,
            u: r,
            a: Sn
        }, mn(n);
    }
    var Fn = F2(function(n, r) {
        return function(e) {
            return n(r(e));
        };
    });
    function Sn(n, r) {
        var e = s, t = ln[n].u, u = Q(null);
        return ln[n].b = u, ln[n].c = F3(function(n, r) {
            return e = r, u;
        }), {
            send: function(n) {
                var u = A2(z, t, n);
                at(u) || m(4);
                for(var a = u.a, i = e; i.b; i = i.b)r(i.a(a));
            }
        };
    }
    var Rn = "undefined" != typeof document ? document : {};
    function Ln(n, r) {
        n.appendChild(r);
    }
    function Dn(n) {
        return {
            $: 0,
            a: n
        };
    }
    var Nn = F2(function(n, r) {
        return F2(function(e, t) {
            for(var u = [], a = 0; t.b; t = t.b){
                var i = t.a;
                a += i.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 1,
                c: r,
                d: Bn(e),
                e: u,
                f: n,
                b: a
            };
        });
    })(void 0);
    F2(function(n, r) {
        return F2(function(e, t) {
            for(var u = [], a = 0; t.b; t = t.b){
                var i = t.a;
                a += i.b.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 2,
                c: r,
                d: Bn(e),
                e: u,
                f: n,
                b: a
            };
        });
    })(void 0);
    var On, kn = F2(function(n, r) {
        return {
            $: 4,
            j: n,
            k: r,
            b: 1 + (r.b || 0)
        };
    }), Cn = F2(function(n, r) {
        return {
            $: "a0",
            n: n,
            o: r
        };
    }), Mn = F2(function(n, r) {
        return {
            $: "a1",
            n: n,
            o: r
        };
    }), In = F2(function(n, r) {
        return {
            $: "a2",
            n: n,
            o: r
        };
    }), Pn = F2(function(n, r) {
        return {
            $: "a3",
            n: n,
            o: r
        };
    });
    function Bn(n) {
        for(var r = {}; n.b; n = n.b){
            var e = n.a, t = e.$, u = e.n, a = e.o;
            if ("a2" !== t) {
                var i = r[t] || (r[t] = {});
                "a3" === t && "class" === u ? xn(i, u, a) : i[u] = a;
            } else "className" === u ? xn(r, u, J(a)) : r[u] = J(a);
        }
        return r;
    }
    function xn(n, r, e) {
        var t = n[r];
        n[r] = t ? t + " " + e : e;
    }
    function jn(n, r) {
        var e = n.$;
        if (5 === e) return jn(n.k || (n.k = n.m()), r);
        if (0 === e) return Rn.createTextNode(n.a);
        if (4 === e) {
            for(var t = n.k, u = n.j; 4 === t.$;)"object" != typeof u ? u = [
                u,
                t.j
            ] : u.push(t.j), t = t.k;
            var a = {
                j: u,
                p: r
            };
            return (i = jn(t, a)).elm_event_node_ref = a, i;
        }
        if (3 === e) return Vn(i = n.h(n.g), r, n.d), i;
        var i = n.f ? Rn.createElementNS(n.f, n.c) : Rn.createElement(n.c);
        Vn(i, r, n.d);
        for(var o = n.e, c = 0; o.length > c; c++)Ln(i, jn(1 === e ? o[c] : o[c].b, r));
        return i;
    }
    function Vn(n, r, e) {
        for(var t in e){
            var u = e[t];
            "a1" === t ? Un(n, u) : "a0" === t ? Kn(n, r, u) : "a3" === t ? zn(n, u) : "a4" === t ? Yn(n, u) : ("value" !== t && "checked" !== t || n[t] !== u) && (n[t] = u);
        }
    }
    function Un(n, r) {
        var e = n.style;
        for(var t in r)e[t] = r[t];
    }
    function zn(n, r) {
        for(var e in r){
            var t = r[e];
            void 0 !== t ? n.setAttribute(e, t) : n.removeAttribute(e);
        }
    }
    function Yn(n, r) {
        for(var e in r){
            var t = r[e], u = t.f, a = t.o;
            void 0 !== a ? n.setAttributeNS(u, e, a) : n.removeAttributeNS(u, e);
        }
    }
    function Kn(n, r, e) {
        var t = n.elmFs || (n.elmFs = {});
        for(var u in e){
            var a = e[u], i = t[u];
            if (a) {
                if (i) {
                    if (i.q.$ === a.$) {
                        i.q = a;
                        continue;
                    }
                    n.removeEventListener(u, i);
                }
                i = qn(r, a), n.addEventListener(u, i, On && {
                    passive: 2 > ft(a)
                }), t[u] = i;
            } else n.removeEventListener(u, i), t[u] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                On = !0;
            }
        }));
    } catch (n) {}
    function qn(n, r) {
        function e(r) {
            var t = e.q, u = Y(t.a, r);
            if (at(u)) {
                for(var a, i = ft(t), o = u.a, c = i ? 3 > i ? o.a : o.ek : o, f = 1 == i ? o.b : 3 == i && o.ci, s = (f && r.stopPropagation(), (2 == i ? o.b : 3 == i && o.cb) && r.preventDefault(), n); a = s.j;){
                    if ("function" == typeof a) c = a(c);
                    else for(var b = a.length; b--;)c = a[b](c);
                    s = s.p;
                }
                s(c, f);
            }
        }
        return e.q = r, e;
    }
    function Wn(n, r) {
        return n.$ == r.$ && G(n.a, r.a);
    }
    function Hn(n, r, e, t) {
        var u = {
            $: r,
            r: e,
            s: t,
            t: void 0,
            u: void 0
        };
        return n.push(u), u;
    }
    function Gn(n, r, e, t) {
        if (n !== r) {
            var u = n.$, a = r.$;
            if (u !== a) {
                if (1 !== u || 2 !== a) return void Hn(e, 0, t, r);
                r = function(n) {
                    for(var r = n.e, e = r.length, t = Array(e), u = 0; e > u; u++)t[u] = r[u].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: t,
                        f: n.f,
                        b: n.b
                    };
                }(r), a = 1;
            }
            switch(a){
                case 5:
                    for(var i = n.l, o = r.l, c = i.length, f = c === o.length; f && c--;)f = i[c] === o[c];
                    if (f) return void (r.k = n.k);
                    r.k = r.m();
                    var s = [];
                    return Gn(n.k, r.k, s, 0), void (s.length > 0 && Hn(e, 1, t, s));
                case 4:
                    for(var b = n.j, l = r.j, v = !1, d = n.k; 4 === d.$;)v = !0, "object" != typeof b ? b = [
                        b,
                        d.j
                    ] : b.push(d.j), d = d.k;
                    for(var g = r.k; 4 === g.$;)v = !0, "object" != typeof l ? l = [
                        l,
                        g.j
                    ] : l.push(g.j), g = g.k;
                    return v && b.length !== l.length ? void Hn(e, 0, t, r) : ((v ? function(n, r) {
                        for(var e = 0; n.length > e; e++)if (n[e] !== r[e]) return !1;
                        return !0;
                    }(b, l) : b === l) || Hn(e, 2, t, l), void Gn(d, g, e, t + 1));
                case 0:
                    return void (n.a !== r.a && Hn(e, 3, t, r.a));
                case 1:
                    return void Xn(n, r, e, t, Qn);
                case 2:
                    return void Xn(n, r, e, t, Zn);
                case 3:
                    if (n.h !== r.h) return void Hn(e, 0, t, r);
                    var h = Jn(n.d, r.d);
                    h && Hn(e, 4, t, h);
                    var m = r.i(n.g, r.g);
                    return void (m && Hn(e, 5, t, m));
            }
        }
    }
    function Xn(n, r, e, t, u) {
        if (n.c === r.c && n.f === r.f) {
            var a = Jn(n.d, r.d);
            a && Hn(e, 4, t, a), u(n, r, e, t);
        } else Hn(e, 0, t, r);
    }
    function Jn(n, r, e) {
        var t;
        for(var u in n)if ("a1" !== u && "a0" !== u && "a3" !== u && "a4" !== u) {
            if (u in r) {
                var a = n[u], i = r[u];
                a === i && "value" !== u && "checked" !== u || "a0" === e && Wn(a, i) || ((t = t || {})[u] = i);
            } else (t = t || {})[u] = e ? "a1" === e ? "" : "a0" === e || "a3" === e ? void 0 : {
                f: n[u].f,
                o: void 0
            } : "string" == typeof n[u] ? "" : null;
        } else {
            var o = Jn(n[u], r[u] || {}, u);
            o && ((t = t || {})[u] = o);
        }
        for(var c in r)c in n || ((t = t || {})[c] = r[c]);
        return t;
    }
    function Qn(n, r, e, t) {
        var u = n.e, a = r.e, i = u.length, o = a.length;
        i > o ? Hn(e, 6, t, {
            v: o,
            i: i - o
        }) : o > i && Hn(e, 7, t, {
            v: i,
            e: a
        });
        for(var c = o > i ? i : o, f = 0; c > f; f++){
            var s = u[f];
            Gn(s, a[f], e, ++t), t += s.b || 0;
        }
    }
    function Zn(n, r, e, t) {
        for(var u = [], a = {}, i = [], o = n.e, c = r.e, f = o.length, s = c.length, b = 0, l = 0, v = t; f > b && s > l;){
            var d = (F = o[b]).a, g = (S = c[l]).a, h = F.b, m = S.b, p = void 0, $ = void 0;
            if (d !== g) {
                var A = o[b + 1], T = c[l + 1];
                if (A) {
                    var E = A.a, y = A.b;
                    $ = g === E;
                }
                if (T) {
                    var w = T.a, _ = T.b;
                    p = d === w;
                }
                if (p && $) Gn(h, _, u, ++v), rr(a, u, d, m, l, i), v += h.b || 0, er(a, u, d, y, ++v), v += y.b || 0, b += 2, l += 2;
                else if (p) v++, rr(a, u, g, m, l, i), Gn(h, _, u, v), v += h.b || 0, b += 1, l += 2;
                else if ($) er(a, u, d, h, ++v), v += h.b || 0, Gn(y, m, u, ++v), v += y.b || 0, b += 2, l += 1;
                else {
                    if (!A || E !== w) break;
                    er(a, u, d, h, ++v), rr(a, u, g, m, l, i), v += h.b || 0, Gn(y, _, u, ++v), v += y.b || 0, b += 2, l += 2;
                }
            } else Gn(h, m, u, ++v), v += h.b || 0, b++, l++;
        }
        for(; f > b;){
            var F;
            v++, er(a, u, (F = o[b]).a, h = F.b, v), v += h.b || 0, b++;
        }
        for(; s > l;){
            var S, R = R || [];
            rr(a, u, (S = c[l]).a, S.b, void 0, R), l++;
        }
        (u.length > 0 || i.length > 0 || R) && Hn(e, 8, t, {
            w: u,
            x: i,
            y: R
        });
    }
    var nr = "_elmW6BL";
    function rr(n, r, e, t, u, a) {
        var i = n[e];
        if (!i) return a.push({
            r: u,
            A: i = {
                c: 0,
                z: t,
                r: u,
                s: void 0
            }
        }), void (n[e] = i);
        if (1 === i.c) {
            a.push({
                r: u,
                A: i
            }), i.c = 2;
            var o = [];
            return Gn(i.z, t, o, i.r), i.r = u, void (i.s.s = {
                w: o,
                A: i
            });
        }
        rr(n, r, e + nr, t, u, a);
    }
    function er(n, r, e, t, u) {
        var a = n[e];
        if (a) {
            if (0 === a.c) {
                a.c = 2;
                var i = [];
                return Gn(t, a.z, i, u), void Hn(r, 9, u, {
                    w: i,
                    A: a
                });
            }
            er(n, r, e + nr, t, u);
        } else {
            var o = Hn(r, 9, u, void 0);
            n[e] = {
                c: 1,
                z: t,
                r: u,
                s: o
            };
        }
    }
    function tr(n, r, e, t) {
        ur(n, r, e, 0, 0, r.b, t);
    }
    function ur(n, r, e, t, u, a, i) {
        for(var o = e[t], c = o.r; c === u;){
            var f = o.$;
            if (1 === f) tr(n, r.k, o.s, i);
            else if (8 === f) o.t = n, o.u = i, (s = o.s.w).length > 0 && ur(n, r, s, 0, u, a, i);
            else if (9 === f) {
                o.t = n, o.u = i;
                var s, b = o.s;
                b && (b.A.s = n, (s = b.w).length > 0 && ur(n, r, s, 0, u, a, i));
            } else o.t = n, o.u = i;
            if (!(o = e[++t]) || (c = o.r) > a) return t;
        }
        var l = r.$;
        if (4 === l) {
            for(var v = r.k; 4 === v.$;)v = v.k;
            return ur(n, v, e, t, u + 1, a, n.elm_event_node_ref);
        }
        for(var d = r.e, g = n.childNodes, h = 0; d.length > h; h++){
            u++;
            var m = 1 === l ? d[h] : d[h].b, p = u + (m.b || 0);
            if (!(u > c || c > p || (o = e[t = ur(g[h], m, e, t, u, p, i)]) && (c = o.r) <= a)) return t;
            u = p;
        }
        return t;
    }
    function ar(n, r) {
        for(var e = 0; r.length > e; e++){
            var t = r[e], u = t.t, a = ir(u, t);
            u === n && (n = a);
        }
        return n;
    }
    function ir(n, r) {
        switch(r.$){
            case 0:
                return function(n, r, e) {
                    var t = n.parentNode, u = jn(r, e);
                    return u.elm_event_node_ref || (u.elm_event_node_ref = n.elm_event_node_ref), t && u !== n && t.replaceChild(u, n), u;
                }(n, r.s, r.u);
            case 4:
                return Vn(n, r.u, r.s), n;
            case 3:
                return n.replaceData(0, n.length, r.s), n;
            case 1:
                return ar(n, r.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = r.s : n.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, n;
            case 6:
                for(var e = r.s, t = 0; e.i > t; t++)n.removeChild(n.childNodes[e.v]);
                return n;
            case 7:
                for(var u = (e = r.s).e, a = n.childNodes[t = e.v]; u.length > t; t++)n.insertBefore(jn(u[t], r.u), a);
                return n;
            case 9:
                if (!(e = r.s)) return n.parentNode.removeChild(n), n;
                var i = e.A;
                return void 0 !== i.r && n.parentNode.removeChild(n), i.s = ar(n, e.w), n;
            case 8:
                return function(n, r) {
                    var e = r.s, t = function(n, r) {
                        if (n) {
                            for(var e = Rn.createDocumentFragment(), t = 0; n.length > t; t++){
                                var u = n[t].A;
                                Ln(e, 2 === u.c ? u.s : jn(u.z, r.u));
                            }
                            return e;
                        }
                    }(e.y, r);
                    n = ar(n, e.w);
                    for(var u = e.x, a = 0; u.length > a; a++){
                        var i = u[a], o = i.A, c = 2 === o.c ? o.s : jn(o.z, r.u);
                        n.insertBefore(c, n.childNodes[i.r]);
                    }
                    return t && Ln(n, t), n;
                }(n, r);
            case 5:
                return r.s(n);
            default:
                m(10);
        }
    }
    function or(n) {
        if (3 === n.nodeType) return Dn(n.textContent);
        if (1 !== n.nodeType) return Dn("");
        for(var r = s, e = n.attributes, t = e.length; t--;){
            var u = e[t];
            r = b(A2(Pn, u.name, u.value), r);
        }
        var a = n.tagName.toLowerCase(), i = s, o = n.childNodes;
        for(t = o.length; t--;)i = b(or(o[t]), i);
        return A3(Nn, a, r, i);
    }
    var cr = F4(function(n, r, e, t) {
        return function(n, r, e, t, u, a) {
            var i = A2(z, n, r ? r.flags : void 0);
            at(i) || m(2);
            var o = {}, c = e(i.a), f = c.a, s = a(l, f), b = function(n, r) {
                var e;
                for(var t in ln){
                    var u = ln[t];
                    u.a && ((e = e || {})[t] = u.a(t, r)), n[t] = dn(u, r);
                }
                return e;
            }(o, l);
            function l(n, r) {
                var e = A2(t, n, f);
                s(f = e.a, r), En(o, e.b, u(f));
            }
            return En(o, c.b, u(f)), b ? {
                ports: b
            } : {};
        }(r, t, n.dZ, n.fc, n.e5, function(r, e) {
            var u = n.fd, a = t.node, i = or(a);
            return function(n, r) {
                r(n);
                var e = 0;
                function t() {
                    e = 1 === e ? 0 : (sr(t), r(n), 1);
                }
                return function(u, a) {
                    n = u, a ? (r(n), 2 === e && (e = 1)) : (0 === e && sr(t), e = 2);
                };
            }(e, function(n) {
                var e = u(n), t = function(n, r) {
                    var e = [];
                    return Gn(n, r, e, 0), e;
                }(i, e);
                a = function(n, r, e, t) {
                    return 0 === e.length ? n : (tr(n, r, e, t), ar(n, e));
                }(a, i, t, r), i = e;
            });
        });
    }), fr = "undefined" != typeof cancelAnimationFrame ? cancelAnimationFrame : function(n) {
        clearTimeout(n);
    }, sr = "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    };
    var br = {
        addEventListener: function() {},
        removeEventListener: function() {}
    }, lr = "undefined" != typeof document ? document : br, vr = "undefined" != typeof window ? window : br, dr = F3(function(n, r, e) {
        return un(Z(function() {
            function t(n) {
                tn(e(n));
            }
            return n.addEventListener(r, t, On && {
                passive: !0
            }), function() {
                n.removeEventListener(r, t);
            };
        }));
    }), gr = F2(function(n, r) {
        var e = Y(n, r);
        return at(e) ? ke(e.a) : Ce;
    });
    var hr = F2(function(n, r) {
        return Z(function() {
            var e = setInterval(function() {
                tn(r);
            }, n);
            return function() {
                clearInterval(e);
            };
        });
    }), mr = new Float64Array(3), pr = new Float64Array(3), $r = new Float64Array(3), Ar = F3(function(n, r, e) {
        return new Float64Array([
            n,
            r,
            e
        ]);
    }), Tr = F2(function(n, r) {
        var e = new Float64Array(3);
        return e[0] = n[0] + r[0], e[1] = n[1] + r[1], e[2] = n[2] + r[2], e;
    });
    function Er(n, r, e) {
        return void 0 === e && (e = new Float64Array(3)), e[0] = n[0] - r[0], e[1] = n[1] - r[1], e[2] = n[2] - r[2], e;
    }
    var yr = F2(Er);
    function wr(n, r) {
        void 0 === r && (r = new Float64Array(3));
        var e = 1 / function(n) {
            return Math.sqrt(n[0] * n[0] + n[1] * n[1] + n[2] * n[2]);
        }(n);
        return r[0] = n[0] * e, r[1] = n[1] * e, r[2] = n[2] * e, r;
    }
    var _r = wr, Fr = F2(function(n, r) {
        return new Float64Array([
            r[0] * n,
            r[1] * n,
            r[2] * n
        ]);
    }), Sr = function(n, r) {
        return n[0] * r[0] + n[1] * r[1] + n[2] * r[2];
    }, Rr = F2(Sr);
    function Lr(n, r, e) {
        return void 0 === e && (e = new Float64Array(3)), e[0] = n[1] * r[2] - n[2] * r[1], e[1] = n[2] * r[0] - n[0] * r[2], e[2] = n[0] * r[1] - n[1] * r[0], e;
    }
    var Dr = F2(Lr), Nr = F2(function(n, r) {
        var e, t = mr, u = new Float64Array(3);
        return t[0] = n[3], t[1] = n[7], t[2] = n[11], e = Sr(r, t) + n[15], t[0] = n[0], t[1] = n[4], t[2] = n[8], u[0] = (Sr(r, t) + n[12]) / e, t[0] = n[1], t[1] = n[5], t[2] = n[9], u[1] = (Sr(r, t) + n[13]) / e, t[0] = n[2], t[1] = n[6], t[2] = n[10], u[2] = (Sr(r, t) + n[14]) / e, u;
    }), Or = new Float64Array(16), kr = new Float64Array(16), Cr = new Float64Array([
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
    ]);
    var Mr = F4(function(n, r, e, t) {
        var u = e * Math.tan(n * Math.PI / 360), a = -u;
        return function(n, r, e, t, u, a) {
            var i = new Float64Array(16);
            return i[0] = 2 * u / (r - n), i[1] = 0, i[2] = 0, i[3] = 0, i[4] = 0, i[5] = 2 * u / (t - e), i[6] = 0, i[7] = 0, i[8] = (r + n) / (r - n), i[9] = (t + e) / (t - e), i[10] = -(a + u) / (a - u), i[11] = -1, i[12] = 0, i[13] = 0, i[14] = -2 * a * u / (a - u), i[15] = 0, i;
        }(a * r, u * r, a, u, e, t);
    });
    function Ir(n, r, e, t, u, a) {
        var i = new Float64Array(16);
        return i[0] = 2 / (r - n), i[1] = 0, i[2] = 0, i[3] = 0, i[4] = 0, i[5] = 2 / (t - e), i[6] = 0, i[7] = 0, i[8] = 0, i[9] = 0, i[10] = -2 / (a - u), i[11] = 0, i[12] = -(r + n) / (r - n), i[13] = -(t + e) / (t - e), i[14] = -(a + u) / (a - u), i[15] = 1, i;
    }
    var Pr = F6(Ir);
    function Br(n, r) {
        var e = new Float64Array(16), t = n[0], u = n[1], a = n[2], i = n[3], o = n[4], c = n[5], f = n[6], s = n[7], b = n[8], l = n[9], v = n[10], d = n[11], g = n[12], h = n[13], m = n[14], p = n[15], $ = r[0], A = r[1], T = r[2], E = r[3], y = r[4], w = r[5], _ = r[6], F = r[7], S = r[8], R = r[9], L = r[10], D = r[11], N = r[12], O = r[13], k = r[14], C = r[15];
        return e[0] = t * $ + o * A + b * T + g * E, e[1] = u * $ + c * A + l * T + h * E, e[2] = a * $ + f * A + v * T + m * E, e[3] = i * $ + s * A + d * T + p * E, e[4] = t * y + o * w + b * _ + g * F, e[5] = u * y + c * w + l * _ + h * F, e[6] = a * y + f * w + v * _ + m * F, e[7] = i * y + s * w + d * _ + p * F, e[8] = t * S + o * R + b * L + g * D, e[9] = u * S + c * R + l * L + h * D, e[10] = a * S + f * R + v * L + m * D, e[11] = i * S + s * R + d * L + p * D, e[12] = t * N + o * O + b * k + g * C, e[13] = u * N + c * O + l * k + h * C, e[14] = a * N + f * O + v * k + m * C, e[15] = i * N + s * O + d * k + p * C, e;
    }
    var xr = F2(Br), jr = F2(function(n, r) {
        var e = new Float64Array(16), t = (r = wr(r, mr))[0], u = r[1], a = r[2], i = Math.cos(n), o = 1 - i, c = Math.sin(n);
        return e[0] = t * t * o + i, e[1] = u * t * o + a * c, e[2] = a * t * o - u * c, e[3] = 0, e[4] = t * u * o - a * c, e[5] = u * u * o + i, e[6] = u * a * o + t * c, e[7] = 0, e[8] = t * a * o + u * c, e[9] = u * a * o - t * c, e[10] = a * a * o + i, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
    });
    var Vr = F2(function(n, r) {
        var e = new Float64Array(16), t = n[0], u = n[1], a = n[2];
        return e[0] = r[0] * t, e[1] = r[1] * t, e[2] = r[2] * t, e[3] = r[3] * t, e[4] = r[4] * u, e[5] = r[5] * u, e[6] = r[6] * u, e[7] = r[7] * u, e[8] = r[8] * a, e[9] = r[9] * a, e[10] = r[10] * a, e[11] = r[11] * a, e[12] = r[12], e[13] = r[13], e[14] = r[14], e[15] = r[15], e;
    });
    var Ur = F2(function(n, r) {
        var e = new Float64Array(16), t = n[0], u = n[1], a = n[2], i = r[0], o = r[1], c = r[2], f = r[3], s = r[4], b = r[5], l = r[6], v = r[7], d = r[8], g = r[9], h = r[10], m = r[11];
        return e[0] = i, e[1] = o, e[2] = c, e[3] = f, e[4] = s, e[5] = b, e[6] = l, e[7] = v, e[8] = d, e[9] = g, e[10] = h, e[11] = m, e[12] = i * t + s * u + d * a + r[12], e[13] = o * t + b * u + g * a + r[13], e[14] = c * t + l * u + h * a + r[14], e[15] = f * t + v * u + m * a + r[15], e;
    }), zr = F3(function(n, r, e) {
        var t, u, a, i = (t = n, u = r, void 0 === (a = mr) && (a = new Float64Array(3)), wr(Er(t, u, a), a)), o = wr(Lr(e, i, pr), pr), c = wr(Lr(i, o, $r), $r), f = Or, s = kr;
        return f[0] = o[0], f[1] = c[0], f[2] = i[0], f[3] = 0, f[4] = o[1], f[5] = c[1], f[6] = i[1], f[7] = 0, f[8] = o[2], f[9] = c[2], f[10] = i[2], f[11] = 0, f[12] = 0, f[13] = 0, f[14] = 0, f[15] = 1, s[0] = 1, s[1] = 0, s[2] = 0, s[3] = 0, s[4] = 0, s[5] = 1, s[6] = 0, s[7] = 0, s[8] = 0, s[9] = 0, s[10] = 1, s[11] = 0, s[12] = -n[0], s[13] = -n[1], s[14] = -n[2], s[15] = 1, Br(f, s);
    }), Yr = 0;
    function Kr(n, r) {
        for(; r.b; r = r.b)n(r.a);
    }
    function qr(n) {
        for(var r = 0; n.b; n = n.b)r++;
        return r;
    }
    var Wr = "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        setTimeout(n, 1e3 / 60);
    }, Hr = F5(function(n, r, e, t, u) {
        return {
            $: 0,
            a: n,
            b: r,
            c: e,
            d: t,
            e: u
        };
    }), Gr = F2(function(n, r) {
        var e = n.blend;
        e.toggle = n.toggle, e.enabled || (n.gl.enable(n.gl.BLEND), e.enabled = !0), e.a === r.a && e.d === r.d || (n.gl.blendEquationSeparate(r.a, r.d), e.a = r.a, e.d = r.d), e.b === r.b && e.c === r.c && e.e === r.e && e.f === r.f || (n.gl.blendFuncSeparate(r.b, r.c, r.e, r.f), e.b = r.b, e.c = r.c, e.e = r.e, e.f = r.f), e.g === r.g && e.h === r.h && e.i === r.i && e.j === r.j || (n.gl.blendColor(r.g, r.h, r.i, r.j), e.g = r.g, e.h = r.h, e.i = r.i, e.j = r.j);
    }), Xr = F2(function(n, r) {
        var e = n.depthTest;
        e.toggle = n.toggle, e.enabled || (n.gl.enable(n.gl.DEPTH_TEST), e.enabled = !0), e.a !== r.a && (n.gl.depthFunc(r.a), e.a = r.a), e.b !== r.b && (n.gl.depthMask(r.b), e.b = r.b), e.c === r.c && e.d === r.d || (n.gl.depthRange(r.c, r.d), e.c = r.c, e.d = r.d);
    }), Jr = F2(function(n, r) {
        var e = n.stencilTest;
        e.toggle = n.toggle, e.enabled || (n.gl.enable(n.gl.STENCIL_TEST), e.enabled = !0), e.d === r.d && e.a === r.a && e.b === r.b || (n.gl.stencilFuncSeparate(n.gl.FRONT, r.d, r.a, r.b), e.d = r.d), e.e === r.e && e.f === r.f && e.g === r.g || (n.gl.stencilOpSeparate(n.gl.FRONT, r.e, r.f, r.g), e.e = r.e, e.f = r.f, e.g = r.g), e.c !== r.c && (n.gl.stencilMask(r.c), e.c = r.c), e.h === r.h && e.a === r.a && e.b === r.b || (n.gl.stencilFuncSeparate(n.gl.BACK, r.h, r.a, r.b), e.h = r.h, e.a = r.a, e.b = r.b), e.i === r.i && e.j === r.j && e.k === r.k || (n.gl.stencilOpSeparate(n.gl.BACK, r.i, r.j, r.k), e.i = r.i, e.j = r.j, e.k = r.k);
    }), Qr = F2(function(n, r) {
        var e = n.scissor;
        e.toggle = n.toggle, e.enabled || (n.gl.enable(n.gl.SCISSOR_TEST), e.enabled = !0), e.a === r.a && e.b === r.b && e.c === r.c && e.d === r.d || (n.gl.scissor(r.a, r.b, r.c, r.d), e.a = r.a, e.b = r.b, e.c = r.c, e.d = r.d);
    }), Zr = F2(function(n, r) {
        var e = n.colorMask;
        e.toggle = n.toggle, e.enabled = !0, e.a === r.a && e.b === r.b && e.c === r.c && e.d === r.d || (n.gl.colorMask(r.a, r.b, r.c, r.d), e.a = r.a, e.b = r.b, e.c = r.c, e.d = r.d);
    }), ne = F2(function(n, r) {
        var e = n.cullFace;
        e.toggle = n.toggle, e.enabled || (n.gl.enable(n.gl.CULL_FACE), e.enabled = !0), e.a !== r.a && (n.gl.cullFace(r.a), e.a = r.a);
    }), re = F2(function(n, r) {
        var e = n.polygonOffset;
        e.toggle = n.toggle, e.enabled || (n.gl.enable(n.gl.POLYGON_OFFSET_FILL), e.enabled = !0), e.a === r.a && e.b === r.b || (n.gl.polygonOffset(r.a, r.b), e.a = r.a, e.b = r.b);
    }), ee = F2(function(n, r) {
        var e = n.sampleCoverage;
        e.toggle = n.toggle, e.enabled || (n.gl.enable(n.gl.SAMPLE_COVERAGE), e.enabled = !0), e.a === r.a && e.b === r.b || (n.gl.sampleCoverage(r.a, r.b), e.a = r.a, e.b = r.b);
    }), te = function(n) {
        n.scissor.enabled && (n.gl.disable(n.gl.SCISSOR_TEST), n.scissor.enabled = !1);
    }, ue = function(n) {
        var r = n.colorMask;
        r.a && r.b && r.c && r.d || (n.gl.colorMask(!0, !0, !0, !0), r.a = !0, r.b = !0, r.c = !0, r.d = !0);
    }, ae = [
        "blend",
        "depthTest",
        "stencilTest",
        "scissor",
        "colorMask",
        "cullFace",
        "polygonOffset",
        "sampleCoverage",
        "sampleAlphaToCoverage"
    ], ie = [
        function(n) {
            n.blend.enabled && (n.gl.disable(n.gl.BLEND), n.blend.enabled = !1);
        },
        function(n) {
            n.depthTest.enabled && (n.gl.disable(n.gl.DEPTH_TEST), n.depthTest.enabled = !1);
        },
        function(n) {
            n.stencilTest.enabled && (n.gl.disable(n.gl.STENCIL_TEST), n.stencilTest.enabled = !1);
        },
        te,
        ue,
        function(n) {
            n.gl.disable(n.gl.CULL_FACE);
        },
        function(n) {
            n.gl.disable(n.gl.POLYGON_OFFSET_FILL);
        },
        function(n) {
            n.gl.disable(n.gl.SAMPLE_COVERAGE);
        },
        function(n) {
            n.gl.disable(n.gl.SAMPLE_ALPHA_TO_COVERAGE);
        }
    ];
    function oe(n, r, e) {
        var t = n.createShader(e);
        return n.shaderSource(t, "#extension GL_OES_standard_derivatives : enable\n" + r), n.compileShader(t), t;
    }
    function ce(n, r) {
        switch(r){
            case n.FLOAT:
                return {
                    size: 1,
                    arraySize: 1,
                    type: Float32Array,
                    baseType: n.FLOAT
                };
            case n.FLOAT_VEC2:
                return {
                    size: 2,
                    arraySize: 1,
                    type: Float32Array,
                    baseType: n.FLOAT
                };
            case n.FLOAT_VEC3:
                return {
                    size: 3,
                    arraySize: 1,
                    type: Float32Array,
                    baseType: n.FLOAT
                };
            case n.FLOAT_VEC4:
                return {
                    size: 4,
                    arraySize: 1,
                    type: Float32Array,
                    baseType: n.FLOAT
                };
            case n.FLOAT_MAT4:
                return {
                    size: 4,
                    arraySize: 4,
                    type: Float32Array,
                    baseType: n.FLOAT
                };
            case n.INT:
                return {
                    size: 1,
                    arraySize: 1,
                    type: Int32Array,
                    baseType: n.INT
                };
        }
    }
    function fe(n, r, e, t) {
        for(var u = e.a.cB, a = [], i = 0; u > i; i++)a.push(String.fromCharCode(97 + i));
        var o = ce(n, r.type);
        if (void 0 === o) throw Error("No info available for: " + r.type);
        var c = 0, f = o.size * o.arraySize * u, s = new o.type(qr(e.b) * f);
        Kr(function(n) {
            !function(n, r, e, t, i) {
                var o;
                if (1 === u) for(o = 0; r > o; o++)n[e++] = 1 === r ? t[i] : t[i][o];
                else a.forEach(function(u) {
                    for(o = 0; r > o; o++)n[e++] = 1 === r ? t[u][i] : t[u][i][o];
                });
            }(s, o.size * o.arraySize, c, n, t[r.name] || r.name), c += f;
        }, e.b);
        var b = n.createBuffer();
        return n.bindBuffer(n.ARRAY_BUFFER, b), n.bufferData(n.ARRAY_BUFFER, s, n.STATIC_DRAW), b;
    }
    function se(n, r) {
        return n + "#" + r;
    }
    var be = F2(function(n, r) {
        var e = n.f, t = e.gl;
        return t ? (t.viewport(0, 0, t.drawingBufferWidth, t.drawingBufferHeight), e.depthTest.b || (t.depthMask(!0), e.depthTest.b = !0), e.stencilTest.c !== e.STENCIL_WRITEMASK && (t.stencilMask(e.STENCIL_WRITEMASK), e.stencilTest.c = e.STENCIL_WRITEMASK), te(e), ue(e), t.clear(t.COLOR_BUFFER_BIT | t.DEPTH_BUFFER_BIT | t.STENCIL_BUFFER_BIT), Kr(function(r) {
            if (r.d.b.b) {
                var u, a, i, o, c;
                if (r.b.id && r.c.id && (u = se(r.b.id, r.c.id), a = e.programs[u]), !a) {
                    var f, s;
                    r.b.id ? f = e.shaders[r.b.id] : r.b.id = Yr++, f || (f = oe(t, r.b.src, t.VERTEX_SHADER), e.shaders[r.b.id] = f), r.c.id ? s = e.shaders[r.c.id] : r.c.id = Yr++, s || (s = oe(t, r.c.src, t.FRAGMENT_SHADER), e.shaders[r.c.id] = s);
                    var b = function(n, r, e) {
                        var t = n.createProgram();
                        if (n.attachShader(t, r), n.attachShader(t, e), n.linkProgram(t), !n.getProgramParameter(t, n.LINK_STATUS)) throw "Link failed: " + n.getProgramInfoLog(t) + "\nvs info-log: " + n.getShaderInfoLog(r) + "\nfs info-log: " + n.getShaderInfoLog(e);
                        return t;
                    }(t, f, s);
                    (a = {
                        glProgram: b,
                        attributes: Object.assign({}, r.b.attributes, r.c.attributes),
                        currentUniforms: {},
                        activeAttributes: [],
                        activeAttributeLocations: []
                    }).uniformSetters = function(n, r, e, t) {
                        var u = e.glProgram, a = e.currentUniforms, i = 0, o = r.f;
                        function c(r, e) {
                            var t = e.name, u = n.getUniformLocation(r, t);
                            switch(e.type){
                                case n.INT:
                                    return function(r) {
                                        a[t] !== r && (n.uniform1i(u, r), a[t] = r);
                                    };
                                case n.FLOAT:
                                    return function(r) {
                                        a[t] !== r && (n.uniform1f(u, r), a[t] = r);
                                    };
                                case n.FLOAT_VEC2:
                                    return function(r) {
                                        a[t] !== r && (n.uniform2f(u, r[0], r[1]), a[t] = r);
                                    };
                                case n.FLOAT_VEC3:
                                    return function(r) {
                                        a[t] !== r && (n.uniform3f(u, r[0], r[1], r[2]), a[t] = r);
                                    };
                                case n.FLOAT_VEC4:
                                    return function(r) {
                                        a[t] !== r && (n.uniform4f(u, r[0], r[1], r[2], r[3]), a[t] = r);
                                    };
                                case n.FLOAT_MAT4:
                                    return function(r) {
                                        a[t] !== r && (n.uniformMatrix4fv(u, !1, new Float32Array(r)), a[t] = r);
                                    };
                                case n.SAMPLER_2D:
                                    var c = i++;
                                    return function(r) {
                                        n.activeTexture(n.TEXTURE0 + c);
                                        var e = o.textures.get(r);
                                        e || (e = r.dG(n), o.textures.set(r, e)), n.bindTexture(n.TEXTURE_2D, e), a[t] !== r && (n.uniform1i(u, c), a[t] = r);
                                    };
                                case n.BOOL:
                                    return function(r) {
                                        a[t] !== r && (n.uniform1i(u, r), a[t] = r);
                                    };
                                default:
                                    return function() {};
                            }
                        }
                        for(var f = {}, s = n.getProgramParameter(u, n.ACTIVE_UNIFORMS), b = 0; s > b; b++){
                            var l = n.getActiveUniform(u, b);
                            f[t[l.name] || l.name] = c(u, l);
                        }
                        return f;
                    }(t, n, a, Object.assign({}, r.b.uniforms, r.c.uniforms));
                    var l = t.getProgramParameter(b, t.ACTIVE_ATTRIBUTES);
                    for(i = 0; l > i; i++){
                        var v = t.getActiveAttrib(b, i), d = t.getAttribLocation(b, v.name);
                        a.activeAttributes.push(v), a.activeAttributeLocations.push(d);
                    }
                    u = se(r.b.id, r.c.id), e.programs[u] = a;
                }
                e.lastProgId !== u && (t.useProgram(a.glProgram), e.lastProgId = u), o = a.uniformSetters, Object.keys(c = r.e).forEach(function(n) {
                    var r = o[n];
                    r && r(c[n]);
                });
                var g = e.buffers.get(r.d);
                for(g || (g = function(n, r) {
                    if (r.a.cM > 0) {
                        var e = n.createBuffer(), t = function(n, r) {
                            var e, t = new Uint32Array(qr(n) * r), u = 0;
                            return Kr(function(n) {
                                if (1 === r) t[u++] = n;
                                else for(e = 0; r > e; e++)t[u++] = n[String.fromCharCode(97 + e)];
                            }, n), t;
                        }(r.c, r.a.cM);
                        return n.bindBuffer(n.ELEMENT_ARRAY_BUFFER, e), n.bufferData(n.ELEMENT_ARRAY_BUFFER, t, n.STATIC_DRAW), {
                            numIndices: t.length,
                            indexBuffer: e,
                            buffers: {}
                        };
                    }
                    return {
                        numIndices: r.a.cB * qr(r.b),
                        indexBuffer: null,
                        buffers: {}
                    };
                }(t, r.d), e.buffers.set(r.d, g)), i = 0; a.activeAttributes.length > i; i++){
                    d = a.activeAttributeLocations[i], void 0 === g.buffers[(v = a.activeAttributes[i]).name] && (g.buffers[v.name] = fe(t, v, r.d, a.attributes)), t.bindBuffer(t.ARRAY_BUFFER, g.buffers[v.name]);
                    var h = ce(t, v.type);
                    if (1 === h.arraySize) t.enableVertexAttribArray(d), t.vertexAttribPointer(d, h.size, h.baseType, !1, 0, 0);
                    else for(var m = 4 * h.size, p = m * h.arraySize, $ = 0; h.arraySize > $; $++)t.enableVertexAttribArray(d + $), t.vertexAttribPointer(d + $, h.size, h.baseType, !1, p, m * $);
                }
                for(e.toggle = !e.toggle, Kr(Ko(e), r.a), i = 0; 9 > i; i++){
                    var A = e[ae[i]];
                    A.toggle !== e.toggle && A.enabled && (ie[i](e), A.enabled = !1, A.toggle = e.toggle);
                }
                g.indexBuffer ? (t.bindBuffer(t.ELEMENT_ARRAY_BUFFER, g.indexBuffer), t.drawElements(r.d.a.cV, g.numIndices, t.UNSIGNED_INT, 0)) : t.drawArrays(r.d.a.cV, 0, g.numIndices);
            }
        }, n.g), r) : r;
    }), le = F3(function(n, r, e) {
        return function(n, r, e, t) {
            return {
                $: 3,
                d: Bn(n),
                g: r,
                h: e,
                i: t
            };
        }(r, {
            g: e,
            f: {},
            h: n
        }, $e, Ae);
    }), ve = F2(function(n, r) {
        n.contextAttributes.alpha = !0, n.contextAttributes.premultipliedAlpha = r.a;
    }), de = F2(function(n, r) {
        n.contextAttributes.depth = !0, n.sceneSettings.push(function(n) {
            n.clearDepth(r.a);
        });
    }), ge = F2(function(n, r) {
        n.contextAttributes.stencil = !0, n.sceneSettings.push(function(n) {
            n.clearStencil(r.a);
        });
    }), he = F2(function(n) {
        n.contextAttributes.antialias = !0;
    }), me = F2(function(n, r) {
        n.sceneSettings.push(function(n) {
            n.clearColor(r.a, r.b, r.c, r.d);
        });
    }), pe = F2(function(n) {
        n.contextAttributes.preserveDrawingBuffer = !0;
    });
    function $e(n) {
        var r = {
            contextAttributes: {
                alpha: !1,
                depth: !1,
                stencil: !1,
                antialias: !1,
                premultipliedAlpha: !1,
                preserveDrawingBuffer: !1
            },
            sceneSettings: []
        };
        Kr(function(n) {
            return A2(Yo, r, n);
        }, n.h);
        var e = Rn.createElement("canvas"), t = e.getContext && (e.getContext("webgl", r.contextAttributes) || e.getContext("experimental-webgl", r.contextAttributes));
        return t && "undefined" != typeof WeakMap ? (r.sceneSettings.forEach(function(n) {
            n(t);
        }), t.getExtension("OES_standard_derivatives"), t.getExtension("OES_element_index_uint"), n.f.gl = t, n.f.toggle = !1, n.f.blend = {
            enabled: !1,
            toggle: !1
        }, n.f.depthTest = {
            enabled: !1,
            toggle: !1
        }, n.f.stencilTest = {
            enabled: !1,
            toggle: !1
        }, n.f.scissor = {
            enabled: !1,
            toggle: !1
        }, n.f.colorMask = {
            enabled: !1,
            toggle: !1
        }, n.f.cullFace = {
            enabled: !1,
            toggle: !1
        }, n.f.polygonOffset = {
            enabled: !1,
            toggle: !1
        }, n.f.sampleCoverage = {
            enabled: !1,
            toggle: !1
        }, n.f.sampleAlphaToCoverage = {
            enabled: !1,
            toggle: !1
        }, n.f.shaders = [], n.f.programs = {}, n.f.lastProgId = null, n.f.buffers = new WeakMap, n.f.textures = new WeakMap, n.f.STENCIL_WRITEMASK = t.getParameter(t.STENCIL_WRITEMASK), Wr(function() {
            return A2(be, n, e);
        })) : (e = Rn.createElement("div")).innerHTML = '<a href="https://get.webgl.org/">Enable WebGL</a> to see this content!', e;
    }
    function Ae(n, r) {
        return r.f = n.f, be(r);
    }
    var Te = 1, Ee = 2, ye = 0, we = l, _e = F3(function(n, r, e) {
        for(;;){
            if (-2 === e.$) return r;
            var t = e.d, u = n, a = A3(n, e.b, e.c, A3(_e, n, r, e.e));
            n = u, r = a, e = t;
        }
    }), Fe = function(n) {
        return A3(_e, F3(function(n, r, e) {
            return A2(we, i(n, r), e);
        }), s, n);
    }, Se = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Re = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Le = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), De = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Ne = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Oe = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ke = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ce = {
        $: 1
    }, Me = function(n) {
        return n + "";
    }, Ie = F3(function(n, r, e) {
        for(;;){
            if (!e.b) return r;
            var t = e.b, u = n, a = A2(n, e.a, r);
            n = u, r = a, e = t;
        }
    }), Pe = F3(function(n, r, e) {
        for(;;){
            if (u(n, r) >= 1) return e;
            var t = n, a = r - 1, i = A2(we, r, e);
            n = t, r = a, e = i;
        }
    }), Be = F2(function(n, r) {
        return A3(Pe, n, r, s);
    }), xe = function(n) {
        return A3(Ie, we, s, n);
    }, je = 32, Ve = F4(function(n, r, e, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: e,
            d: t
        };
    }), Ue = [], ze = T, Ye = F2(function(n, r) {
        return _(r) / _(n);
    }), Ke = ze(A2(Ye, 2, je)), qe = A4(Ve, 0, Ke, Ue, Ue), We = g, He = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ge = E, Xe = function(n) {
        return n.length;
    }, Je = F2(function(n, r) {
        return u(n, r) > 0 ? n : r;
    }), Qe = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ze = h, nt = F2(function(n, r) {
        for(;;){
            var e = A2(Ze, je, n), t = e.b, u = A2(we, Qe(e.a), r);
            if (!t.b) return xe(u);
            n = t, r = u;
        }
    }), rt = F2(function(n, r) {
        for(;;){
            var e = ze(r / je);
            if (1 === e) return A2(Ze, je, n).a;
            n = A2(nt, n, s), r = e;
        }
    }), et = F2(function(n, r) {
        if (r.j) {
            var e = r.j * je, t = Ge(A2(Ye, je, e - 1)), u = n ? xe(r.n) : r.n, a = A2(rt, u, r.j);
            return A4(Ve, Xe(r.m) + e, A2(Je, 5, t * Ke), a, r.m);
        }
        return A4(Ve, Xe(r.m), Ke, Ue, r.m);
    }), tt = F5(function(n, r, e, t, u) {
        for(;;){
            if (0 > r) return A2(et, !1, {
                n: t,
                j: e / je | 0,
                m: u
            });
            var a = He(A3(We, je, r, n));
            r -= je, t = A2(we, a, t);
        }
    }), ut = F2(function(n, r) {
        if (n > 0) {
            var e = n % je;
            return A5(tt, r, n - e - je, n, s, A3(We, e, n - e, r));
        }
        return qe;
    }), at = function(n) {
        return !n.$;
    }, it = P, ot = B, ct = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ft = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, st = function(n) {
        return n;
    }, bt = st, lt = Q, vt = lt(0), dt = F4(function(n, r, e, t) {
        if (t.b) {
            var u = t.a, a = t.b;
            if (a.b) {
                var i = a.a, o = a.b;
                if (o.b) {
                    var c = o.a, f = o.b;
                    if (f.b) {
                        var s = f.b;
                        return A2(n, u, A2(n, i, A2(n, c, A2(n, f.a, e > 500 ? A3(Ie, n, r, xe(s)) : A4(dt, n, r, e + 1, s)))));
                    }
                    return A2(n, u, A2(n, i, A2(n, c, r)));
                }
                return A2(n, u, A2(n, i, r));
            }
            return A2(n, u, r);
        }
        return r;
    }), gt = F3(function(n, r, e) {
        return A4(dt, n, r, 0, e);
    }), ht = F2(function(n, r) {
        return A3(gt, F2(function(r, e) {
            return A2(we, n(r), e);
        }), s, r);
    }), mt = nn, pt = F2(function(n, r) {
        return A2(mt, function(r) {
            return lt(n(r));
        }, r);
    }), $t = F3(function(n, r, e) {
        return A2(mt, function(r) {
            return A2(mt, function(e) {
                return lt(A2(n, r, e));
            }, e);
        }, r);
    }), At = function(n) {
        return A3(gt, $t(we), lt(s), n);
    }, Tt = gn, Et = F2(function(n, r) {
        var e = r;
        return un(A2(mt, Tt(n), e));
    }), yt = F3(function(n, r) {
        return A2(pt, function() {
            return 0;
        }, At(A2(ht, Et(n), r)));
    }), wt = F3(function() {
        return lt(0);
    }), _t = F2(function(n, r) {
        return A2(pt, n, r);
    });
    ln.Task = vn(vt, yt, wt, _t);
    var Ft = mn("Task"), St = F2(function(n, r) {
        return Ft(A2(pt, n, r));
    }), Rt = cr, Lt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Dt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Nt = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Ot = z, kt = k, Ct = R, Mt = A2(it, function(n) {
        return {
            e_: n
        };
    }, A2(kt, "serverUpdateInterval", Ct)), It = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Pt = F3(function(n, r, e) {
        return n(r(e));
    }), Bt = rn, xt = F2(function(n, r) {
        return Ft(A2(Bt, A2(Pt, A2(Pt, lt, n), Se), A2(mt, A2(Pt, A2(Pt, lt, n), Ne), r)));
    }), jt = function(n) {
        return function(n, r) {
            return Z(function(e) {
                sr(function() {
                    var t = document.getElementById(n);
                    e(t ? Q(r(t)) : {
                        $: 1,
                        a: bt(n)
                    });
                });
            });
        }(n, function(n) {
            return {
                dg: {
                    cn: n.scrollWidth,
                    bQ: n.scrollHeight
                },
                fe: {
                    at: n.scrollLeft,
                    au: n.scrollTop,
                    cn: n.clientWidth,
                    bQ: n.clientHeight
                }
            };
        });
    }, Vt = $n, Ut = pn, zt = Ut(s), Yt = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Kt = function(n) {
        return {
            $: 3,
            a: n
        };
    }, qt = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Wt = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Ht = $n, Gt = pn, Xt = Gt(s), Jt = {
        $: 0
    }, Qt = F3(function(n, r, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: e
        };
    }), Zt = F2(function(n, r) {
        return {
            c4: r,
            dj: n
        };
    }), nu = {
        $: -2
    }, ru = nu, eu = lt(A2(Zt, s, ru)), tu = function(n) {
        return i(f(n.a ? "w_" : "d_", n.b), n);
    }, uu = F5(function(n, r, e, t, u) {
        return {
            $: -1,
            a: n,
            b: r,
            c: e,
            d: t,
            e: u
        };
    }), au = F5(function(n, r, e, t, u) {
        if (-1 !== u.$ || u.a) {
            if (-1 !== t.$ || t.a || -1 !== t.d.$ || t.d.a) return A5(uu, n, r, e, t, u);
            var a = t.d;
            return i = t.e, A5(uu, 0, t.b, t.c, A5(uu, 1, a.b, a.c, a.d, a.e), A5(uu, 1, r, e, i, u));
        }
        var i, o = u.b, c = u.c, f = u.d, s = u.e;
        return -1 !== t.$ || t.a ? A5(uu, n, o, c, A5(uu, 0, r, e, t, f), s) : A5(uu, 0, r, e, A5(uu, 1, t.b, t.c, t.d, i = t.e), A5(uu, 1, o, c, f, s));
    }), iu = a, ou = F3(function(n, r, e) {
        if (-2 === e.$) return A5(uu, 0, n, r, nu, nu);
        var t = e.a, u = e.b, a = e.c, i = e.d, o = e.e;
        switch(A2(iu, n, u)){
            case 0:
                return A5(au, t, u, a, A3(ou, n, r, i), o);
            case 1:
                return A5(uu, t, u, r, i, o);
            default:
                return A5(au, t, u, a, i, A3(ou, n, r, o));
        }
    }), cu = F3(function(n, r, e) {
        var t = A3(ou, n, r, e);
        return -1 !== t.$ || t.a ? t : A5(uu, 1, t.b, t.c, t.d, t.e);
    }), fu = function(n) {
        return A3(Ie, F2(function(n, r) {
            return A3(cu, n.a, n.b, r);
        }), ru, n);
    }, su = function(n) {
        return Z(function(r) {
            var e = n.f;
            2 === e.$ && e.c && e.c(), n.f = null, r(Q(0));
        });
    }, bu = F3(function(n, r, e) {
        for(;;){
            if (-2 === e.$) return r;
            var t = e.e, u = n, a = A3(n, e.b, e.c, A3(bu, n, r, e.d));
            n = u, r = a, e = t;
        }
    }), lu = F6(function(n, r, e, t, a, o) {
        var c = A3(bu, F3(function(t, a, o) {
            n: for(;;){
                var c = o.a, f = o.b;
                if (c.b) {
                    var s = c.a, b = s.a, l = s.b, v = c.b;
                    if (0 > u(b, t)) {
                        o = i(v, A3(n, b, l, f));
                        continue n;
                    }
                    return u(b, t) > 0 ? i(c, A3(e, t, a, f)) : i(v, A4(r, b, l, a, f));
                }
                return i(c, A3(e, t, a, f));
            }
        }), i(Fe(t), o), a), f = c.a, s = c.b;
        return A3(Ie, F2(function(r, e) {
            return A3(n, r.a, r.b, e);
        }), s, f);
    }), vu = F2(function(n, r) {
        return {
            cH: r,
            cN: n
        };
    }), du = hn, gu = F3(function(n, r, e) {
        return A2(pt, function(n) {
            return i(r, n);
        }, A3(dr, e.a ? vr : lr, e.b, function(e) {
            return A2(du, n, A2(vu, r, e));
        }));
    }), hu = F2(function(n, r) {
        return A3(bu, cu, r, n);
    }), mu = F3(function(n, r, e) {
        var t = F3(function(r, e, t) {
            var u = t.c;
            return o(t.a, t.b, A2(we, A3(gu, n, r, e), u));
        }), u = F3(function(n, r, e) {
            var t = e.b, u = e.c;
            return o(A2(we, r, e.a), t, u);
        }), a = F4(function(n, r, e, t) {
            var u = t.c;
            return o(t.a, A3(cu, n, r, t.b), u);
        }), i = A2(ht, tu, r), c = A6(lu, u, a, t, e.c4, fu(i), o(s, ru, s)), f = c.b, b = c.c;
        return A2(mt, function(n) {
            return lt(A2(Zt, i, A2(hu, f, fu(n))));
        }, A2(mt, function() {
            return At(b);
        }, At(A2(ht, su, c.a))));
    }), pu = F3(function(n, r, e) {
        var t = n(r);
        return t.$ ? e : A2(we, t.a, e);
    }), $u = F2(function(n, r) {
        return A3(gt, pu(n), s, r);
    }), Au = F3(function(n, r, t) {
        var u = r.cN, a = r.cH, i = A2($u, function(n) {
            var r = n.b.c;
            return e(n.a, u) ? A2(gr, r, a) : Ce;
        }, t.dj);
        return A2(mt, function() {
            return lt(t);
        }, At(A2(ht, Tt(n), i)));
    }), Tu = F2(function(n, r) {
        return A3(Qt, r.a, r.b, A2(it, n, r.c));
    });
    ln["Browser.Events"] = vn(eu, mu, Au, 0, Tu);
    var Eu = mn("Browser.Events"), yu = F3(function(n, r, e) {
        return Eu(A3(Qt, n, r, e));
    }), wu = function(n) {
        return A3(yu, 1, "resize", A2(kt, "target", A3(ot, n, A2(kt, "innerWidth", Ct), A2(kt, "innerHeight", Ct))));
    }, _u = Gt(v([
        wu(F2(function() {
            return Jt;
        }))
    ])), Fu = {
        $: 1
    }, Su = O, Ru = _n("messageReceiver", Su), Lu = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Du = F3(function(n, r, e) {
        return {
            b2: e,
            de: r,
            dj: n
        };
    }), Nu = lt(A3(Du, s, Ce, 0)), Ou = Z(function(n) {
        n(Q(Date.now()));
    }), ku = Z(function(n) {
        var r = sr(function() {
            n(Q(Date.now()));
        });
        return function() {
            fr(r);
        };
    }), Cu = un, Mu = F3(function(n, r, e) {
        var t = e.de, u = e.b2, a = i(t, r);
        return 1 === a.a.$ ? a.b.b ? A2(mt, function(n) {
            return A2(mt, function(e) {
                return lt(A3(Du, r, ke(n), e));
            }, Ou);
        }, Cu(A2(mt, du(n), ku))) : Nu : a.b.b ? lt(A3(Du, r, t, u)) : A2(mt, function() {
            return Nu;
        }, su(a.a.a));
    }), Iu = st, Pu = F3(function(n, r, e) {
        var t = e.dj, u = e.b2, a = function(e) {
            return A2(Tt, n, (0, e.a)(e.$ ? r - u : Iu(r)));
        };
        return A2(mt, function(n) {
            return A2(mt, function() {
                return lt(A3(Du, t, ke(n), r));
            }, At(A2(ht, a, t)));
        }, Cu(A2(mt, du(n), ku)));
    });
    ln["Browser.AnimationManager"] = vn(Nu, Mu, Pu, 0, F2(function(n, r) {
        return r.$ ? {
            $: 1,
            a: A2(Pt, n, r.a)
        } : Lu(A2(Pt, n, r.a));
    }));
    var Bu, xu = mn("Browser.AnimationManager"), ju = function(n) {
        return xu(Lu(n));
    }, Vu = U, Uu = D, zu = A2(it, function(n) {
        return {
            dN: n
        };
    }, A2(kt, "earth", A3(ot, F2(function(n, r) {
        return {
            eU: r,
            eV: n
        };
    }), A2(kt, "rotationAroundSun", Uu), A2(kt, "rotationAroundAxis", Uu)))), Yu = function(n) {
        return A2(Vu, zu, n);
    }, Ku = Gt(v([
        ju(function(n) {
            return {
                $: 0,
                a: n
            };
        }),
        wu(F2(function() {
            return Fu;
        })),
        Ru(function(n) {
            var r = Yu(n);
            return r.$ ? {
                $: 5,
                a: "Error while communicating with the server"
            } : {
                $: 4,
                a: r.a
            };
        })
    ])), qu = {
        $: 1
    }, Wu = Gt(v([
        ju(function(n) {
            return {
                $: 0,
                a: n
            };
        }),
        wu(F2(function() {
            return qu;
        })),
        Ru(function(n) {
            var r = Yu(n);
            return r.$ ? {
                $: 4,
                a: "Error while communicating with the server"
            } : {
                $: 3,
                a: r.a
            };
        })
    ])), Hu = {
        $: 0
    }, Gu = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Xu = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Ju = F2(function(n, r) {
        return {
            c8: r,
            dk: n
        };
    }), Qu = lt(A2(Ju, ru, ru)), Zu = F2(function(n, r) {
        n: for(;;){
            if (-2 === r.$) return Ce;
            var e = r.c, t = r.d, u = r.e;
            switch(A2(iu, n, r.b)){
                case 0:
                    r = t;
                    continue n;
                case 1:
                    return ke(e);
                default:
                    r = u;
                    continue n;
            }
        }
    }), na = F2(function(n, r) {
        var e = n.a, t = n.b, u = A2(Zu, e, r);
        return A3(cu, e, 1 === u.$ ? v([
            t
        ]) : A2(we, t, u.a), r);
    }), ra = hr, ea = F3(function(n, r, e) {
        if (r.b) {
            var t = r.a, u = r.b, a = Cu(A2(ra, t, A2(du, n, t)));
            return A2(mt, function(r) {
                return A3(ea, n, u, A3(cu, t, r, e));
            }, a);
        }
        return lt(e);
    }), ta = F3(function(n, r, e) {
        var t = e.c8, u = F3(function(n, r, e) {
            var t = e.c;
            return o(e.a, e.b, A2(mt, function() {
                return t;
            }, su(r)));
        }), a = A3(Ie, na, ru, r), i = A6(lu, F3(function(n, r, e) {
            var t = e.b, u = e.c;
            return o(A2(we, n, e.a), t, u);
        }), F4(function(n, r, e, t) {
            var u = t.c;
            return o(t.a, A3(cu, n, e, t.b), u);
        }), u, a, t, o(s, ru, lt(0))), c = i.a, f = i.b;
        return A2(mt, function(n) {
            return lt(A2(Ju, a, n));
        }, A2(mt, function() {
            return A3(ea, n, c, f);
        }, i.c));
    }), ua = (Bu = Iu, Z(function(n) {
        n(Q(Bu(Date.now())));
    })), aa = F3(function(n, r, e) {
        var t = A2(Zu, r, e.dk);
        if (1 === t.$) return lt(e);
        var u = t.a;
        return A2(mt, function() {
            return lt(e);
        }, A2(mt, function(r) {
            return At(A2(ht, function(e) {
                return A2(Tt, n, e(r));
            }, u));
        }, ua));
    }), ia = F2(function(n, r) {
        return A2(Xu, r.a, A2(Pt, n, r.b));
    });
    ln.Time = vn(Qu, ta, aa, 0, ia);
    var oa = mn("Time"), ca = F2(function(n, r) {
        return oa(A2(Xu, n, r));
    }), fa = N, sa = _n("objReceiver", fa), ba = Gt(v([
        wu(F2(function() {
            return Hu;
        })),
        sa(function(n) {
            return {
                $: 2,
                a: n
            };
        }),
        A2(ca, 1e3, Gu)
    ])), la = {
        $: 0
    }, va = Gt(v([
        wu(F2(function() {
            return la;
        }))
    ])), da = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), ga = F5(function(n, r, e, t, u) {
        return {
            $: 4,
            a: n,
            b: r,
            c: e,
            d: t,
            e: u
        };
    }), ha = F3(function(n, r, e) {
        return {
            $: 3,
            a: n,
            b: r,
            c: e
        };
    }), ma = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), pa = F2(function(n, r) {
        return i({
            cx: {
                dO: n,
                e_: r
            },
            cm: {
                es: ""
            }
        }, zt);
    }), $a = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Aa = F4(function(n, r, e, t) {
        return i({
            bM: {
                dB: e,
                ey: !1,
                eR: n
            },
            bh: r,
            co: {
                dA: {
                    bK: 0,
                    aN: 0
                },
                t: {
                    cA: !1,
                    bi: 1,
                    eD: {
                        at: 0,
                        au: 0
                    },
                    bE: {
                        at: 0,
                        au: 0
                    },
                    dq: !1
                },
                dN: r.dN.bs,
                dV: t
            }
        }, A2(xt, $a, jt("webgl-canvas")));
    }), Ta = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Ea = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ya = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), wa = function(n) {
        var r = n.b;
        return A2(ya, 1664525 * n.a + r >>> 0, r);
    }, _a = A2(mt, function(n) {
        var r, e;
        return lt((r = n, e = wa(A2(ya, 0, 1013904223)), wa(A2(ya, e.a + r >>> 0, e.b))));
    }, ua), Fa = F2(function(n, r) {
        return n(r);
    }), Sa = F3(function(n, r, e) {
        if (r.b) {
            var t = r.b, u = A2(Fa, r.a, e), a = u.b;
            return A2(mt, function() {
                return A3(Sa, n, t, a);
            }, A2(Tt, n, u.a));
        }
        return lt(e);
    }), Ra = F3(function(n, r, e) {
        return lt(e);
    }), La = F2(function(n, r) {
        var e = r;
        return function(r) {
            var t = e(r), u = t.b;
            return i(n(t.a), u);
        };
    }), Da = F2(function(n, r) {
        return A2(La, n, r);
    });
    ln.Random = vn(_a, Sa, Ra, Da);
    var Na, Oa, ka, Ca, Ma, Ia, Pa, Ba, xa, ja, Va, Ua, za, Ya, Ka, qa, Wa, Ha, Ga, Xa, Ja, Qa, Za, ni, ri, ei, ti, ui, ai, ii, oi, ci, fi, si, bi = mn("Random"), li = F2(function(n, r) {
        return bi(A2(La, n, r));
    }), vi = function(n) {
        return {
            bk: n
        };
    }, di = F3(function(n, r, e) {
        return {
            cE: e,
            cF: r,
            cG: n
        };
    }), gi = function(n) {
        return 0 > n ? -n : n;
    }, hi = function(n) {
        var r = n.a, e = 277803737 * (r ^ r >>> (r >>> 28) + 4);
        return (e >>> 22 ^ e) >>> 0;
    }, mi = F2(function(n, r) {
        return function(e) {
            var t = wa(e), u = gi(r - n), a = hi(t);
            return i((1 * (67108863 & hi(e)) * 134217728 + 1 * (134217727 & a)) / 9007199254740992 * u + n, wa(t));
        };
    }), pi = F4(function(n, r, e, t) {
        var u = r, a = e, o = t;
        return function(r) {
            var e = u(r), t = e.a, c = a(e.b), f = c.a, s = o(c.b), b = s.b;
            return i(A3(n, t, f, s.a), b);
        };
    }), $i = i({
        bD: {
            dB: Ce,
            bh: Ce,
            dV: Ce,
            eR: Ce
        }
    }, Ut(v([
        A2(li, Ta, A2(La, vi, A4(pi, di, A2(mi, 0, 1), A2(mi, 0, 1), A2(mi, 0, 1)))),
        A2(xt, Ea, jt("webgl-canvas"))
    ]))), Ai = function(n) {
        return i({
            ek: n
        }, 0);
    }, Ti = {
        $: 4
    }, Ei = function(n) {
        return {
            $: 1,
            a: n
        };
    }, yi = F2(function(n) {
        return n;
    }), wi = F2(function(n, r) {
        switch(n.$){
            case 2:
                return i(r, "" !== r.cm.es ? A2(St, yi(Ti), lt(0)) : zt);
            case 3:
                return i(c(r, {
                    cm: {
                        es: n.a
                    }
                }), zt);
            case 0:
                return i(r, A2(xt, Ei, jt("webgl-canvas")));
            default:
                return i(r, zt);
        }
    }), _i = {
        $: 8
    }, Fi = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Si = .2, Ri = .3, Li = function(n) {
        return n.b;
    }, Di = i(800, 800), Ni = F3(function(n, r, e) {
        var t = Si * Di.a / 2, a = Si * Di.b / 4, i = n.bQ / 2 * (1.2 - e * Si / (n.bQ / Di.b));
        return 0 > u(gi(n.cn / 2 * 1.5 - r.a), t) && 0 > u(gi(i - r.b), a);
    }), Oi = F2(function(n, r) {
        return A3(Ni, n, r, -0.8);
    }), ki = F2(function(n, r) {
        return A3(Ni, n, r, .8);
    }), Ci = y, Mi = F3(function(n, r, e) {
        var t = !!A2(ki, e, r);
        return c(n, {
            cA: !!A2(Oi, e, r),
            bi: 0,
            eD: {
                at: Ci(r.a),
                au: Ci(r.b)
            },
            bE: {
                at: Ci(r.a),
                au: Ci(r.b)
            },
            dq: t
        });
    }), Ii = p, Pi = F3(function(n, r, e) {
        var t = n.bi ? r.aN : r.aN - (Ci(e.b) - n.bE.au) * Ii * (1 / 4) / 180;
        return i(c(n, {
            bE: {
                at: Ci(e.a),
                au: Ci(e.b)
            }
        }), c(r, {
            bK: n.bi ? r.bK : r.bK + (Ci(e.a) - n.bE.at) * Ii * (1 / 4) / 180,
            aN: 1 > u(t, 1.2566370614359172) && u(t, -1.2566370614359172) > -1 ? t : r.aN
        }));
    }), Bi = function(n) {
        return n.b ? ke(n.a) : Ce;
    }, xi = F2(function(n, r) {
        return r.$ ? Se(r.a) : Ne(n(r.a));
    }), ji = Tr, Vi = function(n) {
        return n[0];
    }, Ui = function(n) {
        return n[1];
    }, zi = function(n) {
        return n[2];
    }, Yi = Ar, Ki = _r, qi = F4(function(n, r, e, t) {
        var u = gi(e - n);
        return r + t * (e - r ? (e - r) / gi(e - r) : 0) * u;
    }), Wi = F2(function(n, r) {
        return 0 > u(n, r) ? n : r;
    }), Hi = F4(function(n, r, e, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: e,
            d: t
        };
    }), Gi = F2(function(n, r) {
        var e = i(n, r), t = e.a, u = t.a, a = t.b, o = t.c, c = t.d, f = e.b, s = f.a, b = f.b, l = f.c, v = f.d;
        return A4(Hi, u * s - a * b - o * l - c * v, u * b + a * s + o * v - c * l, u * l - a * v + o * s + c * b, u * v + a * l - o * b + c * s);
    }), Xi = Dr, Ji = Rr, Qi = Fr, Zi = F3(function(n, r, e) {
        var t = Ki(A2(Xi, A2(Xi, n, r), n)), u = Ki(n);
        return A2(ji, A2(Qi, A2(Ji, e, u), u), A2(Qi, A2(Ji, e, t), t));
    }), no = A, ro = yr, eo = F2(function(n, r) {
        var e = A4(Hi, 0, Vi(r), Ui(r), zi(r));
        return function(n) {
            return A3(Yi, n.b, n.c, n.d);
        }(A2(Gi, A2(Gi, n, e), function(n) {
            return A4(Hi, n.a, -n.b, -n.c, -n.d);
        }(n)));
    }), to = A4(Hi, 1, 0, 0, 0), uo = $, ao = F2(function(n, r) {
        return A4(Hi, uo(r / 2), no(r / 2) * Vi(n), no(r / 2) * Ui(n), no(r / 2) * zi(n));
    }), io = w, oo = F2(function(n, r) {
        if (.99999999999 > A2(Ji, n, r)) {
            if (1 > u(A2(Ji, n, r), -0.99999999999)) return A2(ao, A2(Xi, n, A3(Yi, .3, .7, .1)), Ii);
            var e = A2(Xi, n, r), t = Ui(e), a = zi(e), i = Vi(e), o = 1 + A2(Ji, n, r), c = io(o * o + i * i + t * t + a * a);
            return A4(Hi, o / c, i / c, t / c, a / c);
        }
        return to;
    }), co = F6(function(n, r, e, t, u, a) {
        var o, f, s, b = r - e, l = b / n, v = no(r / 1e3) / 20, d = a.dV, g = A2(oo, A3(Yi, 0, 1, 0), d.d0), h = a.dN, m = {
            eU: A4(qi, u.eU, h.eU, t.eU, l),
            eV: A4(qi, u.eV, h.eV, t.eV, l)
        }, p = a.t, $ = A2(Je, .5, A2(Wi, 1.5, d.eI + b * (p.dq ? 5e-4 : p.cA ? -0.0005 : 0))), A = A2(Je, 105, A2(Wi, 150, d.dv + b * (($ - 1) / 500))), T = A2(Gi, A2(oo, A2(eo, g, A3(Yi, 0, 0, 1)), d.ex), g), E = A2(ji, d.d0, A2(eo, T, A3(Yi, 0, 0, 0))), y = Ki(A2(ji, E, A2(Qi, b * d.er, A2(ro, A2(ji, d.d0, A2(eo, T, A2(Qi, .001, d.eq))), E)))), w = (o = Ki(y), Vi(o), f = Ui(o), s = zi(o), gi(s) > .1 ? function(n) {
            var r = zi(n), e = Ui(n) / r, t = Vi(n);
            return i(A3(Yi, 1, 0, -t / r), A3(Yi, 0, 1, -e));
        }(o) : gi(f) > .1 ? function(n) {
            var r = zi(n), e = Ui(n), t = r / e, u = Vi(n);
            return i(A3(Yi, 1, -u / e, 0), A3(Yi, 0, -t, 1));
        }(o) : function(n) {
            var r = zi(n), e = Ui(n), t = Vi(n), u = r / t;
            return i(A3(Yi, -e / t, 1, 0), A3(Yi, -u, 0, 1));
        }(o)), _ = c(d, {
            dv: A,
            d0: y,
            ex: Ki(A3(Zi, w.a, w.b, A2(eo, A2(oo, d.d0, y), d.ex))),
            eI: $,
            eW: v
        });
        return c(a, {
            dN: m,
            dV: _
        });
    }), fo = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), so = F2(function(n, r) {
        switch(n.$){
            case 5:
                var e = n.a;
                return i(r, A2(St, yi(_i), lt(0)));
            case 4:
                var t = c(u = r.bh, {
                    dN: {
                        bs: {
                            eU: (e = n.a).dN.eU,
                            eV: e.dN.eV
                        },
                        c6: r.co.dN,
                        eO: u.dN.bs
                    }
                });
                return i(c(r, {
                    bh: t
                }), A2(St, Fi, ua));
            case 6:
                return t = c(u = r.bh, {
                    dP: {
                        cY: n.a,
                        eP: u.dP.cY
                    }
                }), i(c(r, {
                    bh: t
                }), zt);
            case 0:
                var u, a = r.co, o = n.a, f = (u = r.bh).dN, s = ($ = r.bM).eR.dP, b = c($, {
                    eR: {
                        dP: o,
                        eN: s
                    }
                });
                return i(c(r, {
                    bM: b,
                    co: d = A6(co, r.cx.e_, o, s, f.bs, f.c6, a)
                }), zt);
            case 2:
                var l = n.a;
                switch(l.$){
                    case 0:
                        var v = c((a = r.co).t, {
                            cA: !1,
                            bi: 1,
                            dq: !1
                        }), d = c(a, {
                            t: v
                        });
                        return i(c(r, {
                            co: d
                        }), zt);
                    case 1:
                        return d = c(a = r.co, {
                            t: v = A3(Mi, a.t, l.a.c_, ($ = r.bM).dB)
                        }), i(c(r, {
                            co: d
                        }), zt);
                    case 2:
                        var g = A3(Pi, (a = r.co).t, a.dA, l.a.c_);
                        return d = c(a, {
                            dA: g.b,
                            t: v = g.a
                        }), i(c(r, {
                            co: d
                        }), zt);
                    case 5:
                        return v = c((a = r.co).t, {
                            cA: !1,
                            bi: 1,
                            dq: !1
                        }), d = c(a, {
                            t: v
                        }), i(c(r, {
                            co: d
                        }), zt);
                    case 4:
                        var h = Bi(l.a.dn);
                        return 1 === h.$ ? i(r, zt) : (d = c(a = r.co, {
                            t: v = A3(Mi, a.t, h.a.cv, ($ = r.bM).dB)
                        }), i(c(r, {
                            co: d
                        }), zt));
                    default:
                        var m = Bi(l.a.dn);
                        if (1 === m.$) return i(r, zt);
                        var p = A3(Pi, (a = r.co).t, a.dA, m.a.cv);
                        return d = c(a, {
                            dA: p.b,
                            t: v = p.a
                        }), i(c(r, {
                            co: d
                        }), zt);
                }
            case 1:
                return i(r, A2(xt, $a, jt("webgl-canvas")));
            case 3:
                return b = c($ = r.bM, {
                    dB: A2(fo, $.dB, A2(xi, function(n) {
                        return {
                            bQ: Ci(n.bQ),
                            cn: Ci(n.cn)
                        };
                    }, A2(xi, function(n) {
                        return n.fe;
                    }, n.a)))
                }), i(c(r, {
                    bM: b
                }), zt);
            case 7:
                var $;
                return b = c($ = r.bM, {
                    ey: !$.ey
                }), i(c(r, {
                    bM: b
                }), zt);
            default:
                return i(r, zt);
        }
    }), bo = function(n) {
        return {
            $: 5,
            a: n
        };
    }, lo = F2(function(n, r) {
        return r.$ ? Ce : ke(n(r.a));
    }), vo = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), go = F2(function(n, r) {
        switch(n.$){
            case 4:
                var e = n.a, t = c(_ = r.bD, {
                    bh: Ce
                });
                return i(c(r, {
                    bD: t
                }), zt);
            case 3:
                var u = {
                    eU: (e = n.a).dN.eU,
                    eV: e.dN.eV
                }, a = (_ = r.bD).bh;
                if (a.$) return f = {
                    dN: ke({
                        bs: u,
                        eO: Ce
                    }),
                    dP: Ce
                }, t = c(_, {
                    bh: ke(f)
                }), i(c(r, {
                    bD: t
                }), A2(St, bo, ua));
                var o = {
                    bs: u,
                    eO: ke(A2(vo, u, A2(lo, function(n) {
                        return n.bs;
                    }, (l = a.a).dN)))
                }, f = c(l, {
                    dN: ke(o)
                });
                t = c(_, {
                    bh: ke(f)
                });
                return i(c(r, {
                    bD: t
                }), A2(St, bo, ua));
            case 5:
                var s = n.a, b = (_ = r.bD).bh;
                if (b.$) return i(r, zt);
                var l, v = {
                    cY: p = s,
                    eP: ke(A2(vo, p, A2(lo, function(n) {
                        return n.cY;
                    }, (l = b.a).dP)))
                };
                return f = c(l, {
                    dP: ke(v)
                }), t = c(_, {
                    bh: ke(f)
                }), i(c(r, {
                    bD: t
                }), zt);
            case 0:
                s = n.a;
                var d = (_ = r.bD).eR, g = A2(vo, Ce, A2(lo, function(n) {
                    return n.eP;
                }, A2(vo, Ce, A2(lo, function(n) {
                    return n.dP;
                }, _.bh)))), h = A2(vo, Ce, A2(lo, function(n) {
                    return n.eO;
                }, A2(vo, Ce, A2(lo, function(n) {
                    return n.dN;
                }, _.bh)))), m = i(g, i(A2(lo, function(n) {
                    return n.cY;
                }, A2(vo, Ce, A2(lo, function(n) {
                    return n.dP;
                }, _.bh))), i(h, i(A2(lo, function(n) {
                    return n.bs;
                }, A2(vo, Ce, A2(lo, function(n) {
                    return n.dN;
                }, _.bh))), i(d, i(_.dV, _.dB))))));
                if (m.a.$ || m.b.a.$ || m.b.b.a.$ || m.b.b.b.a.$ || m.b.b.b.b.a.$ || m.b.b.b.b.b.a.$ || m.b.b.b.b.b.b.$) return t = c(_, {
                    eR: ke({
                        dP: s,
                        eN: A2(lo, function(n) {
                            return n.dP;
                        }, _.eR)
                    })
                }), i(c(r, {
                    bD: t
                }), zt);
                var p, $ = m.b, A = $.b, T = A.b, E = T.b, y = E.b;
                return i(r, A2(St, yi({
                    $: 7,
                    a: {
                        dB: y.b.a,
                        bh: f = {
                            dN: {
                                bs: u = T.a.a,
                                c6: u,
                                eO: A.a.a
                            },
                            dP: {
                                cY: p = $.a.a,
                                eP: m.a.a
                            }
                        },
                        dV: R = y.a.a,
                        eR: {
                            dP: s,
                            eN: E.a.a.dP
                        }
                    }
                }), lt(0)));
            case 1:
                return i(r, A2(xt, Ea, jt("webgl-canvas")));
            case 2:
                return t = c(_ = r.bD, {
                    dB: A2(vo, _.dB, A2(lo, ke, (L = A2(xi, function(n) {
                        return {
                            bQ: Ci(n.bQ),
                            cn: Ci(n.cn)
                        };
                    }, A2(xi, function(n) {
                        return n.fe;
                    }, n.a))).$ ? Ce : ke(L.a)))
                }), i(c(r, {
                    bD: t
                }), zt);
            case 6:
                var w = n.a, _ = r.bD, F = Ki(A3(Yi, 0, -1, 0)), S = Ki(A3(Yi, .9397, 0, -0.342)), R = {
                    dv: 105,
                    dS: A3(Yi, w.bk.cG, w.bk.cF, w.bk.cE),
                    d0: S,
                    eq: Ki(A3(Yi, 0, 0, -1)),
                    er: .01,
                    ex: F,
                    eI: 1,
                    eW: 0
                };
                return t = c(_, {
                    dV: ke(R)
                }), i(c(r, {
                    bD: t
                }), zt);
            default:
                return i(r, zt);
        }
        var L;
    }), ho = F2(function(n, r) {
        return r.b ? A3(gt, we, r, n) : n;
    }), mo = function(n) {
        return A3(gt, ho, s, n);
    }, po = F3(function(n, r, e) {
        return {
            cx: n,
            cL: e,
            dm: r
        };
    }), $o = x, Ao = C, To = F2(function(n, r) {
        return {
            dE: n,
            aD: r
        };
    }), Eo = A4($o, function(n) {
        return function(r) {
            return function(e) {
                return A3(Yi, n, r, e);
            };
        };
    }, A2(Ao, 0, Uu), A2(Ao, 1, Uu), A2(Ao, 2, Uu)), yo = A3(ot, To, A2(kt, "color", Eo), A2(kt, "position", Eo)), wo = {
        $: 3,
        b: A4($o, function(n) {
            return function(r) {
                return function(e) {
                    return o(n, r, e);
                };
            };
        }, A2(Ao, 0, yo), A2(Ao, 1, yo), A2(Ao, 2, yo))
    }, _o = A4($o, po, A2(kt, "data", wo), A2(kt, "totalAmount", Ct), A2(kt, "index", Ct)), Fo = d, So = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    })({
        cB: 3,
        cM: 0,
        cV: 4
    }), Ro = F2(function(n, r) {
        switch(n.$){
            case 0:
                return i(r, A2(xt, It, jt("webgl-canvas")));
            case 2:
                var t = A2(Ot, _o, n.a);
                if (t.$) return i(r, A2(St, yi({
                    $: 4,
                    a: "Could not download the assets"
                }), lt(0)));
                var u = t.a, a = u.dm, o = A2(ho, (d = r.bR).bC, v([
                    i(u.cL, u.cx)
                ])), f = c(d, {
                    bC: o
                }), s = c(r, {
                    bR: f
                });
                if (e((g = o, A3(Ie, F2(function(n, r) {
                    return r + 1;
                }), 0, g)), a)) {
                    var b = mo(A2(ht, Li, A2(Fo, F2(function(n, r) {
                        return A2(iu, n.a, r.a);
                    }), o))), l = {
                        dO: So(b),
                        e_: r.bR.e_
                    };
                    return i(s, A2(St, yi({
                        $: 3,
                        a: l
                    }), lt(0)));
                }
                return i(s, zt);
            case 5:
                var d;
                return f = c(d = r.bR, {
                    aY: d.aY + 1
                }), i(c(r, {
                    bR: f
                }), zt);
            default:
                return i(r, zt);
        }
        var g;
    }), Lo = {
        $: 3
    }, Do = function(n) {
        return {
            $: 1,
            a: n
        };
    }, No = function(n) {
        switch(n.$){
            case 2:
                return i(0, A2(St, yi(Lo), lt(0)));
            case 0:
                return i(0, A2(xt, Do, jt("webgl-canvas")));
            default:
                return i(0, zt);
        }
    }, Oo = F2(function(n, r) {
        var e = i(n, r);
        n: for(;;)switch(e.a.$){
            case 0:
                if (e.b.$) break n;
                var t = e.b.a;
                switch(($ = e.a.a).$){
                    case 3:
                        var u = A2(pa, (h = $.a).dO, h.e_), a = u.b;
                        return i(A2(da, (w = u.a).cx, w.cm), A2(Vt, Yt, a));
                    case 4:
                        var o = Ai($.a);
                        return i(Nt((w = o.a).ek), zt);
                    default:
                        var c = A2(Ro, $, {
                            bR: t
                        });
                        return a = c.b, i(Lt((w = c.a).bR), A2(Vt, Dt, a));
                }
            case 1:
                if (1 === e.b.$) {
                    var f = e.b, s = f.a, b = f.b;
                    if (4 === ($ = e.a.a).$) return i(A2(ma, s, b), zt);
                    var l = A2(wi, $, {
                        cm: b
                    });
                    return a = l.b, i(A2(da, s, (w = l.a).cm), A2(Vt, Yt, a));
                }
                break n;
            case 2:
                if (2 === e.b.$) {
                    var v = e.b;
                    return s = v.a, b = v.b, 3 === ($ = e.a.a).$ ? (a = $i.b, i(A3(ha, s, b, (w = $i.a).bD), A2(Vt, Kt, a))) : (a = No($).b, i(A2(ma, s, b), A2(Vt, Wt, a)));
                }
                break n;
            case 3:
                if (3 === e.b.$) {
                    var d = e.b, g = (s = d.a, b = d.b, d.c);
                    if (7 === ($ = e.a.a).$) {
                        var h, m = A4(Aa, (h = $.a).eR, h.bh, h.dB, h.dV);
                        return a = m.b, i(A5(ga, s, b, (w = m.a).bh, w.bM, w.co), A2(Vt, qt, a));
                    }
                    var p = A2(go, $, {
                        bD: g
                    });
                    return a = p.b, i(A3(ha, s, b, (w = p.a).bD), A2(Vt, Kt, a));
                }
                break n;
            default:
                if (4 === e.b.$) {
                    var $, A = e.b, T = (s = A.a, b = A.b, A.c), E = A.d, y = A.e;
                    if (8 === ($ = e.a.a).$) return a = $i.b, i(A3(ha, s, b, (w = $i.a).bD), A2(Vt, Kt, a));
                    var w, _ = A2(so, $, {
                        bM: E,
                        bh: T,
                        cx: s,
                        co: y
                    });
                    return a = _.b, i(A5(ga, s, b, (w = _.a).bh, w.bM, w.co), A2(Vt, qt, a));
                }
                break n;
        }
        return i(r, zt);
    }), ko = kn, Co = {
        $: 2
    }, Mo = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Io = Nn("button"), Po = function(n) {
        return n;
    }, Bo = F2(function(n, r) {
        return A2(In, n, Po(r));
    }), xo = Bo("className"), jo = Nn("div"), Vo = function(n) {
        return A2(Pn, "height", Me(n));
    }, Uo = Bo("id"), zo = Mn, Yo = F2(function(n, r) {
        switch(r.$){
            case 0:
                return A2(ve, n, r);
            case 1:
                return A2(de, n, r);
            case 2:
                return A2(ge, n, r);
            case 3:
                return A2(he, n, r);
            case 4:
                return A2(me, n, r);
            default:
                return A2(pe, n, r);
        }
    }), Ko = F2(function(n, r) {
        switch(r.$){
            case 0:
                return A2(Gr, n, r);
            case 1:
                return A2(Xr, n, r);
            case 2:
                return A2(Jr, n, r);
            case 3:
                return A2(Qr, n, r);
            case 4:
                return A2(Zr, n, r);
            case 5:
                return A2(ne, n, r);
            case 6:
                return A2(re, n, r);
            case 7:
                return A2(ee, n, r);
            default:
                return function(n) {
                    var r = n.sampleAlphaToCoverage;
                    r.toggle = n.toggle, r.enabled || (n.gl.enable(n.gl.SAMPLE_ALPHA_TO_COVERAGE), r.enabled = !0);
                }(n);
        }
    }), qo = F3(function(n, r, e) {
        return A3(le, n, r, e);
    })(v([
        (si = !0, {
            $: 0,
            a: si
        }),
        {
            $: 3
        },
        function(n) {
            return {
                $: 1,
                a: n
            };
        }(1)
    ])), Wo = F4(function(n, r, e, t) {
        var u;
        return A2(jo, f(v([
            Uo("canvas-container")
        ]), n), f(r, v([
            A2(qo, f(v([
                (u = Di.a, A2(Pn, "width", Me(u))),
                Vo(Di.b),
                A2(zo, "display", "block"),
                A2(zo, "height", "100vh"),
                A2(zo, "width", "100vw"),
                Uo("webgl-canvas")
            ]), e), t)
        ])));
    }), Ho = Nn("input"), Go = Cn, Xo = F2(function(n, r) {
        return A2(Go, n, {
            $: 0,
            a: r
        });
    }), Jo = function(n) {
        return A2(Xo, "click", ct(n));
    }, Qo = function(n) {
        return i(n, !0);
    }, Zo = F2(function(n, r) {
        return A2(Go, n, {
            $: 1,
            a: r
        });
    }), nc = A2(F2(function(n, r) {
        return A3(gt, kt, r, n);
    }), v([
        "target",
        "value"
    ]), Su), rc = Nn("p"), ec = Bo("placeholder"), tc = Dn, uc = Bo("value"), ac = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ic = function(n) {
        return {
            $: 2,
            a: n
        };
    }, oc = function(n) {
        return {
            $: 0,
            a: n
        };
    }, cc = function(n) {
        return {
            $: 2,
            a: n
        };
    }, fc = function(n) {
        return {
            $: 4,
            a: n
        };
    }, sc = function(n) {
        return {
            $: 3,
            a: n
        };
    }, bc = function(n) {
        return {
            $: 5,
            a: n
        };
    }, lc = function(n) {
        var r = 1 / (.5 * (1 + io(5))), e = A2(To, n, Ki(A3(Yi, 0, r, -1))), t = A2(To, n, Ki(A3(Yi, -1, 0, -r))), u = A2(To, n, Ki(A3(Yi, r, -1, 0))), a = A2(To, n, Ki(A3(Yi, -r, -1, 0))), i = A2(To, n, Ki(A3(Yi, r, 1, 0))), c = A2(To, n, Ki(A3(Yi, -r, 1, 0))), f = A2(To, n, Ki(A3(Yi, 0, r, 1))), s = A2(To, n, Ki(A3(Yi, 0, -r, 1))), b = A2(To, n, Ki(A3(Yi, -1, 0, r))), l = A2(To, n, Ki(A3(Yi, 0, -r, -1))), d = A2(To, n, Ki(A3(Yi, 1, 0, -r))), g = A2(To, n, Ki(A3(Yi, 1, 0, r)));
        return v([
            o(c, i, e),
            o(i, c, f),
            o(b, s, f),
            o(s, g, f),
            o(d, l, e),
            o(l, t, e),
            o(a, u, s),
            o(u, a, l),
            o(t, b, c),
            o(b, t, a),
            o(g, d, i),
            o(d, g, u),
            o(c, b, f),
            o(g, i, f),
            o(t, c, e),
            o(i, d, e),
            o(a, t, l),
            o(d, u, l),
            o(b, a, s),
            o(u, g, s)
        ]);
    }, vc = F2(function(n, r) {
        if (r.b) {
            var e = r.a, t = e.a, u = e.b, a = e.c, i = r.b;
            return A2(we, o(c(t, {
                aD: n(t.aD)
            }), c(u, {
                aD: n(u.aD)
            }), c(a, {
                aD: n(a.aD)
            })), A2(vc, n, i));
        }
        return s;
    }), dc = (Na = A2(Qi, 1 / 255, A3(Yi, 204, 0, 0)), So(mo(v([
        A2(vc, ji(A3(Yi, 0, 1.1, 0)), A2(vc, Qi(.03), lc(Na))),
        A2(vc, ji(A3(Yi, 0, 1.2, 0)), A2(vc, Qi(.03), lc(Na))),
        A2(vc, ji(A3(Yi, 0, 1.3, 0)), A2(vc, Qi(.03), lc(Na))),
        A2(vc, ji(A3(Yi, 0, 1.4, 0)), A2(vc, Qi(.03), lc(Na))),
        A2(vc, ji(A3(Yi, 0, 1.5, 0)), A2(vc, Qi(.03), lc(Na))),
        A2(vc, ji(A3(Yi, 0, 1.6, 0)), A2(vc, Qi(.03), lc(Na))),
        A2(vc, ji(A3(Yi, 0, 1.7, 0)), A2(vc, Qi(.03), lc(Na))),
        A2(vc, ji(A3(Yi, 0, 1.8, 0)), A2(vc, Qi(.03), lc(Na))),
        A2(vc, ji(A3(Yi, 0, 1.9, 0)), A2(vc, Qi(.03), lc(Na))),
        A2(vc, ji(A3(Yi, 0, 2, 0)), A2(vc, Qi(.03), lc(Na))),
        A2(vc, ji(A3(Yi, 0, -1.1, 0)), A2(vc, Qi(.03), lc(Na))),
        A2(vc, ji(A3(Yi, 0, -1.2, 0)), A2(vc, Qi(.03), lc(Na))),
        A2(vc, ji(A3(Yi, 0, -1.3, 0)), A2(vc, Qi(.03), lc(Na))),
        A2(vc, ji(A3(Yi, 0, -1.4, 0)), A2(vc, Qi(.03), lc(Na))),
        A2(vc, ji(A3(Yi, 0, -1.5, 0)), A2(vc, Qi(.03), lc(Na))),
        A2(vc, ji(A3(Yi, 0, -1.6, 0)), A2(vc, Qi(.03), lc(Na))),
        A2(vc, ji(A3(Yi, 0, -1.7, 0)), A2(vc, Qi(.03), lc(Na))),
        A2(vc, ji(A3(Yi, 0, -1.8, 0)), A2(vc, Qi(.03), lc(Na))),
        A2(vc, ji(A3(Yi, 0, -1.9, 0)), A2(vc, Qi(.03), lc(Na))),
        A2(vc, ji(A3(Yi, 0, -2, 0)), A2(vc, Qi(.03), lc(Na)))
    ])))), gc = Cr, hc = A3(Ar, 0, 1, 0), mc = zr, pc = jr, $c = function(n) {
        var r, e, t = n.a, u = n.b, a = n.c, i = n.d;
        return r = {
            d1: 2 * (t * t + u * u) - 1,
            d2: 2 * (u * a - t * i),
            d3: 2 * (u * i + t * a),
            d4: 0,
            d5: 2 * (u * a + t * i),
            d6: 2 * (t * t + a * a) - 1,
            d7: 2 * (a * i - t * u),
            d8: 0,
            d9: 2 * (u * i - t * a),
            ea: 2 * (a * i + t * u),
            eb: 2 * (t * t + i * i) - 1,
            ec: 0,
            ed: 0,
            ee: 0,
            ef: 0,
            eg: 1
        }, (e = new Float64Array(16))[0] = r.d1, e[1] = r.d5, e[2] = r.d9, e[3] = r.ed, e[4] = r.d2, e[5] = r.d6, e[6] = r.ea, e[7] = r.ee, e[8] = r.d3, e[9] = r.d7, e[10] = r.eb, e[11] = r.ef, e[12] = r.d4, e[13] = r.d8, e[14] = r.ec, e[15] = r.eg, e;
    }, Ac = Nr, Tc = F4(function(n, r, e, t) {
        var u = A2(oo, A3(Yi, 0, 1, 0), e.d0), a = A3(Yi, 0, 0, 2), i = t.aN, o = 1e3 * (uo(r.eV) - no(r.eV)), c = 1e3 * (uo(r.eV) + no(r.eV)), f = A3(Yi, c, 0, o), s = A2(pc, r.eU, A2(Ac, A2(pc, .41015237421866746, A3(Yi, 0, 0, 1)), hc)), b = A2(Ac, A2(pc, t.bK, A3(Yi, 0, 1, 0)), a), l = A2(Ac, A2(pc, i, A2(Xi, b, A3(Yi, 0, 1, 0))), b), v = A2(Gi, A2(oo, A2(eo, u, A3(Yi, 0, 0, 1)), e.ex), u), d = A2(ji, f, A2(Ac, s, A2(Ac, A2(pc, .41015237421866746, A3(Yi, 0, 0, 1)), A2(ji, A2(Qi, e.dv, e.d0), A2(Ac, $c(v), l))))), g = A2(ji, f, A2(Ac, s, A2(Ac, A2(pc, .41015237421866746, A3(Yi, 0, 0, 1)), A2(ji, A2(Qi, e.dv, e.d0), A2(Ac, $c(v), A3(Yi, 0, 0, 0)))))), h = A2(Ac, s, A2(Ac, A2(pc, .41015237421866746, A3(Yi, 0, 0, 1)), A2(Ac, $c(v), hc)));
        return A3(mc, d, g, h);
    }), Ec = F3(function() {
        return A3(mc, A3(Yi, 0, 0, -4000), A3(Yi, 0, 0, 0), A3(Yi, 0, 1, 0));
    }), yc = Mr, wc = F6(function(n, r, e, t, u, a) {
        var i = e.cn / e.bQ;
        return {
            dA: n ? A3(Ec, e, t, u) : A4(Tc, e, t, u, a),
            eA: n ? A4(yc, 45, i, .1, 1e4) : A4(yc, 20, i, .1, r),
            eF: gc,
            eG: gc,
            eH: gc,
            eJ: gc,
            eK: gc,
            eL: gc,
            eT: gc,
            eX: gc,
            e$: .75,
            fb: gc
        };
    }), _c = xr, Fc = Vr, Sc = Ur, Rc = F6(function(n, r, e, t, u, a) {
        var i = A6(wc, n, r, e, t, u, a), o = A2(Fc, A3(Yi, 100, 100, 100), gc), f = A2(_c, A2(pc, .41015237421866746, A3(Yi, 0, 0, 1)), A2(pc, t.eU, A3(Yi, 0, 1, 0))), s = A2(pc, -1.5707963267948966, A3(Yi, 1, 0, 0)), b = 1e3 * (uo(t.eV) - no(t.eV)), l = 1e3 * (uo(t.eV) + no(t.eV));
        return c(i, {
            eJ: s,
            eT: f,
            eX: o,
            fb: A2(Sc, A3(Yi, l, 0, b), gc)
        });
    }), Lc = F6(function(n, r, e, t, u, a) {
        return c(A6(Rc, n, r, e, t, u, a), {
            eJ: gc
        });
    }), Dc = F2(function(n, r) {
        if (r.b) {
            var e = r.a, t = e.a, u = e.b, a = e.c, i = r.b;
            return A2(we, o(c(t, {
                aD: n(t.aD)
            }), c(u, {
                aD: n(u.aD)
            }), c(a, {
                aD: n(a.aD)
            })), A2(Dc, n, i));
        }
        return s;
    }), Nc = So(mo(v([
        A2(Dc, ji(A3(Yi, 0, -0.3, 0)), v([
            o(A2(To, A3(Yi, 0, 0, 1), A3(Yi, -1, 0, 0)), A2(To, A3(Yi, 1, 0, 0), A3(Yi, 0, -1, 0)), A2(To, A3(Yi, 0, 0, 1), A3(Yi, 1, 0, 0)))
        ]))
    ]))), Oc = So(mo(v([
        A2(Dc, ji(A3(Yi, 0, Ri, 0)), v([
            o(A2(To, A3(Yi, 0, 0, 1), A3(Yi, 1, 0, 0)), A2(To, A3(Yi, 0, 1, 0), A3(Yi, 0, 1, 0)), A2(To, A3(Yi, 0, 0, 1), A3(Yi, -1, 0, 0)))
        ]))
    ]))), kc = Pr, Cc = F2(function(n, r) {
        var e = n.bQ / Di.b, t = n.cn / Di.a, u = A2(Sc, A3(Yi, .5, -0.2, 0), gc), a = A2(Fc, A3(Yi, Si / t, Si / e, 1), gc);
        return {
            dA: A3(mc, A3(Yi, 0, 0, 1), A3(Yi, 0, 0, 0), A3(Yi, 0, 1, 0)),
            eA: A6(kc, -1, 1, -1, 1, 0, 10),
            eF: gc,
            eG: gc,
            eH: gc,
            eJ: gc,
            eK: gc,
            eL: gc,
            eT: gc,
            eX: a,
            e$: r,
            fb: u
        };
    }), Mc = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Ic = A4(F4(function(n, r, e, t) {
        return {
            $: 1,
            a: n,
            b: r,
            c: e,
            d: t
        };
    }), 513, {
        N: 1,
        O: 0,
        R: !0
    }.R, 0, 1), Pc = Hr, Bc = So(mo(v([
        lc(A2(Qi, 1 / 255, A3(Yi, 245, 121, 0)))
    ]))), xc = F6(function(n, r, e, t, u, a) {
        var i = A6(wc, n, r, e, t, u, a), o = A2(Sc, A2(Qi, u.dv, u.d0), gc), f = A2(oo, A3(Yi, 0, 1, 0), u.d0), s = A2(Fc, A3(Yi, .01, .01, .01), gc), b = 1e3 * (uo(t.eV) - no(t.eV)), l = 1e3 * (uo(t.eV) + no(t.eV)), d = A2(Sc, A3(Yi, l, 0, b), gc), g = A2(pc, t.eU, A2(Ac, A2(pc, .41015237421866746, A3(Yi, 0, 0, 1)), hc));
        return c(i, {
            eF: A3(Ie, _c, gc, v([
                A2(pc, .41015237421866746, A3(Yi, 0, 0, 1)),
                g
            ])),
            eH: d,
            eK: s,
            eT: A2(_c, $c(A2(Gi, A2(oo, A2(eo, f, A3(Yi, 0, 0, 1)), u.ex), f)), A2(_c, A2(pc, 3 * u.eW, A3(Yi, 0, 1, 0)), A2(_c, A2(pc, 2 * u.eW, A3(Yi, 1, 0, 0)), gc))),
            fb: o
        });
    }), jc = F6(function(n, r, e, t, u, a) {
        var i = A6(xc, n, r, e, t, u, a), o = A2(Sc, A3(Yi, 0, .025, 0), gc);
        return c(i, {
            eK: A3(Ie, _c, gc, v([
                A2(Fc, A3(Yi, u.eI / 2, u.eI / 2, u.eI / 2), gc),
                i.eK
            ])),
            eL: o
        });
    }), Vc = Nn("span"), Uc = function(n) {
        var r = Me(Ci(1e3 / (n.dP - n.eN)));
        return A2(jo, v([
            Uo("fps-overlay")
        ]), v([
            A2(Vc, s, v([
                tc("FPS: " + r)
            ]))
        ]));
    }, zc = {
        src: "\n    precision mediump float;\n    uniform float shade;\n    varying vec3 vcolor;\n    void main () {\n      gl_FragColor = shade * vec4(vcolor, 1.0);\n    }\n  ",
        attributes: {},
        uniforms: {
            shade: "e$"
        }
    }, Yc = {
        src: "\n    precision mediump float;\n    uniform float shade;\n    varying vec3 vcolor;\n    void main () {\n      gl_FragColor = shade * vec4(vcolor, 1.0);\n    }\n  ",
        attributes: {},
        uniforms: {
            shade: "e$"
        }
    }, Kc = F5(function(n, r, e, t, u) {
        var a = function(r) {
            return A2(To, n, r);
        };
        return v([
            o(a(r), a(e), a(t)),
            o(a(t), a(u), a(r))
        ]);
    }), qc = function(n) {
        var r = A3(Yi, 1, 1, 1), e = A3(Yi, 1, -1, 1), t = A3(Yi, 1, 1, -1), u = A3(Yi, 1, -1, -1), a = A3(Yi, -1, 1, 1), i = A3(Yi, -1, -1, 1), o = A3(Yi, -1, 1, -1), c = A3(Yi, -1, -1, -1), f = v([
            A5(Kc, n, r, e, u, t),
            A5(Kc, n, a, i, e, r),
            A5(Kc, n, t, o, a, r),
            A5(Kc, n, e, i, c, u),
            A5(Kc, n, o, c, i, a),
            A5(Kc, n, t, u, c, o)
        ]);
        return mo(f);
    }, Wc = function(n) {
        var r, e, t, u;
        return r = n[0], e = n[1], t = n[2], (u = new Float64Array(16))[0] = r, u[1] = 0, u[2] = 0, u[3] = 0, u[4] = 0, u[5] = e, u[6] = 0, u[7] = 0, u[8] = 0, u[9] = 0, u[10] = t, u[11] = 0, u[12] = 0, u[13] = 0, u[14] = 0, u[15] = 1, u;
    }, Hc = (Oa = A2(Qi, 1 / 255, A3(Yi, 133, 87, 35)), ka = A2(vc, ji(A3(Yi, 1, 0, 0)), A2(vc, function(n) {
        return A2(Ac, Wc(A3(Yi, .1, 1, 1)), n);
    }, qc(Oa))), Ca = A2(vc, ji(A3(Yi, -1, 0, 0)), A2(vc, function(n) {
        return A2(Ac, Wc(A3(Yi, .1, 1, 1)), n);
    }, qc(Oa))), Ma = A2(vc, ji(A3(Yi, 0, 0, 1)), A2(vc, function(n) {
        return A2(Ac, Wc(A3(Yi, 1, 1, .1)), n);
    }, qc(Oa))), Ia = A2(Qi, 1 / 255, A3(Yi, 20, 20, 20)), Pa = A2(vc, ji(A3(Yi, 0, 1.1, 1)), A2(vc, function(n) {
        return A2(Ac, Wc(A3(Yi, 1, .1, .1)), n);
    }, qc(Ia))), Ba = A2(vc, ji(A3(Yi, -1, 1.1, 0)), A2(vc, function(n) {
        return A2(Ac, Wc(A3(Yi, .1, .1, 1)), n);
    }, qc(Ia))), xa = A2(vc, ji(A3(Yi, 1, 1.1, 0)), A2(vc, function(n) {
        return A2(Ac, Wc(A3(Yi, .1, .1, 1)), n);
    }, qc(Ia))), ja = A2(vc, ji(A3(Yi, 0, -1, 0)), A2(vc, function(n) {
        return A2(Ac, Wc(A3(Yi, 1, .1, 1)), n);
    }, qc(Oa))), Va = A2(vc, ji(A3(Yi, 0, 0, -1)), A2(vc, function(n) {
        return A2(Ac, Wc(A3(Yi, 1, 1, .1)), n);
    }, qc(Oa))), Ua = A2(vc, ji(A3(Yi, 0, 1.1, -1)), A2(vc, function(n) {
        return A2(Ac, Wc(A3(Yi, 1, .1, .1)), n);
    }, qc(Ia))), A2(vc, ji(A3(Yi, 0, -1.5, 0)), mo(v([
        Ma,
        Pa,
        Va,
        Ua,
        ka,
        xa,
        Ca,
        Ba,
        ja
    ])))), Gc = function(n) {
        var r, e, t, u;
        return r = n[0], e = n[1], t = n[2], (u = new Float64Array(16))[0] = 1, u[1] = 0, u[2] = 0, u[3] = 0, u[4] = 0, u[5] = 1, u[6] = 0, u[7] = 0, u[8] = 0, u[9] = 0, u[10] = 1, u[11] = 0, u[12] = r, u[13] = e, u[14] = t, u[15] = 1, u;
    }, Xc = (za = A2(Qi, 1 / 255, A3(Yi, 200, 200, 200)), Ka = A2(vc, function(n) {
        return A2(Ac, Gc(A3(Yi, 0, 1.5, 0)), n);
    }, A2(vc, function(n) {
        return A2(Ac, Wc(A3(Yi, .8, .1, .8)), n);
    }, qc(Ya = A2(Qi, 1 / 255, A3(Yi, 30, 30, 30))))), qa = A2(vc, function(n) {
        return A2(Ac, Gc(A3(Yi, 0, 1.7, 0)), n);
    }, A2(vc, function(n) {
        return A2(Ac, Wc(A3(Yi, .2, .2, .2)), n);
    }, qc(Ya))), Wa = A2(vc, ji(A3(Yi, .7, 0, .7)), A2(vc, function(n) {
        return A2(Ac, A2(pc, .05, A3(Yi, 1, 0, -1)), n);
    }, A2(vc, function(n) {
        return A2(Ac, Gc(A3(Yi, 0, 3.5, 0)), n);
    }, A2(vc, function(n) {
        return A2(Ac, Wc(A3(Yi, .05, 2, .05)), n);
    }, qc(za))))), Ha = A2(vc, ji(A3(Yi, -0.7, 0, .7)), A2(vc, function(n) {
        return A2(Ac, A2(pc, .05, A3(Yi, 1, 0, 1)), n);
    }, A2(vc, function(n) {
        return A2(Ac, Gc(A3(Yi, 0, 3.5, 0)), n);
    }, A2(vc, function(n) {
        return A2(Ac, Wc(A3(Yi, .05, 2, .05)), n);
    }, qc(za))))), Ga = A2(Qi, 1 / 255, A3(Yi, 113, 121, 126)), Xa = A2(vc, ji(A3(Yi, -1, 0, 1)), A2(vc, function(n) {
        return A2(Ac, A2(pc, .3, A3(Yi, -1, 0, -1)), n);
    }, A2(vc, function(n) {
        return A2(Ac, Gc(A3(Yi, 0, .5, 0)), n);
    }, A2(vc, function(n) {
        return A2(Ac, Wc(A3(Yi, .1, 1, .1)), n);
    }, qc(Ga))))), Ja = A2(vc, ji(A3(Yi, 1, 0, 1)), A2(vc, function(n) {
        return A2(Ac, A2(pc, .3, A3(Yi, -1, 0, 1)), n);
    }, A2(vc, function(n) {
        return A2(Ac, Gc(A3(Yi, 0, .5, 0)), n);
    }, A2(vc, function(n) {
        return A2(Ac, Wc(A3(Yi, .1, 1, .1)), n);
    }, qc(Ga))))), Qa = A2(vc, ji(A3(Yi, .7, 0, -0.7)), A2(vc, function(n) {
        return A2(Ac, A2(pc, .05, A3(Yi, -1, 0, -1)), n);
    }, A2(vc, function(n) {
        return A2(Ac, Gc(A3(Yi, 0, 3.5, 0)), n);
    }, A2(vc, function(n) {
        return A2(Ac, Wc(A3(Yi, .05, 2, .05)), n);
    }, qc(za))))), Za = A2(vc, ji(A3(Yi, 1, 0, -1)), A2(vc, function(n) {
        return A2(Ac, A2(pc, .3, A3(Yi, 1, 0, 1)), n);
    }, A2(vc, function(n) {
        return A2(Ac, Gc(A3(Yi, 0, .5, 0)), n);
    }, A2(vc, function(n) {
        return A2(Ac, Wc(A3(Yi, .1, 1, .1)), n);
    }, qc(Ga))))), ni = A2(vc, ji(A3(Yi, -0.7, 0, -0.7)), A2(vc, function(n) {
        return A2(Ac, A2(pc, .05, A3(Yi, -1, 0, 1)), n);
    }, A2(vc, function(n) {
        return A2(Ac, Gc(A3(Yi, 0, 3.5, 0)), n);
    }, A2(vc, function(n) {
        return A2(Ac, Wc(A3(Yi, .05, 2, .05)), n);
    }, qc(za))))), ri = A2(vc, ji(A3(Yi, -1, 0, -1)), A2(vc, function(n) {
        return A2(Ac, A2(pc, .3, A3(Yi, 1, 0, -1)), n);
    }, A2(vc, function(n) {
        return A2(Ac, Gc(A3(Yi, 0, .5, 0)), n);
    }, A2(vc, function(n) {
        return A2(Ac, Wc(A3(Yi, .1, 1, .1)), n);
    }, qc(Ga))))), A2(vc, ji(A3(Yi, 0, 0, 0)), mo(v([
        Ja,
        Xa,
        ri,
        Za,
        Ka,
        qa,
        Wa,
        Ha,
        ni,
        Qa
    ])))), Jc = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var e = r.b;
            if (n(r.a)) return !0;
            r = e;
        }
    }), Qc = F2(function(n, r) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    n -= 1, r = r.b;
                    continue n;
                }
                return r;
            }
            return r;
        }
    }), Zc = F2(function(n, r) {
        var e = function(r) {
            if (r.b) {
                var t = r.a, u = t.a, a = t.b, i = t.c, c = r.b, f = (zi(a.aD) + zi(i.aD)) / 2, b = (Ui(a.aD) + Ui(i.aD)) / 2, l = (Vi(a.aD) + Vi(i.aD)) / 2, d = A3(Yi, l, b, f), g = (zi(u.aD) + zi(i.aD)) / 2, h = (Ui(u.aD) + Ui(i.aD)) / 2, m = (Vi(u.aD) + Vi(i.aD)) / 2, p = A3(Yi, m, h, g), $ = (zi(u.aD) + zi(a.aD)) / 2, A = (Ui(u.aD) + Ui(a.aD)) / 2, T = (Vi(u.aD) + Vi(a.aD)) / 2, E = A3(Yi, T, A, $), y = A2(To, n, Ki(d)), w = A2(To, n, Ki(p)), _ = A2(To, n, Ki(E));
                return A2(we, v([
                    o(u, _, w),
                    o(_, a, y),
                    o(y, i, w),
                    o(w, _, y)
                ]), e(c));
            }
            return s;
        };
        return mo(e(r));
    }), nf = (ei = function(n) {
        var r = Bi(n);
        if (1 === r.$) return s;
        var e, t, a, i = r.a, c = function(n) {
            var r = Ui(n.aD), e = (1 + uo(Ii * (1 + (r + 1) / 2))) / 2, t = io(1 - (r + 1) / 2 * ((r + 1) / 2)), u = io(Vi(n.aD) * Vi(n.aD) + zi(n.aD) * zi(n.aD)), a = u > .1 ? e * t / u : u;
            return {
                dE: n.dE,
                aD: A2(Ac, Wc(A3(Yi, a, 1, a)), n.aD)
            };
        }, f = A2(Jc, function(n) {
            return u(Ui(n.aD), -0.75) > 0;
        }, v([
            e = i.a,
            t = i.b,
            a = i.c
        ])) ? v([
            o(c(e), c(t), c(a))
        ]) : s;
        return A2(ho, f, ei(A2(Qc, 1, n)));
    }, ti = function(n) {
        var r = Bi(n);
        if (1 === r.$) return s;
        var e = r.a, t = v([
            o(e.c, e.b, e.a)
        ]);
        return A2(ho, t, ti(A2(Qc, 1, n)));
    }, ai = A2(Qi, 2 / 3, ui = A2(Qi, 1 / 255, A3(Yi, 160, 221, 100))), ii = ti(A2(vc, Qi(.99), A2(Zc, ai, A2(Zc, ai, A2(Zc, ai, lc(ai)))))), oi = A2(Zc, ui, A2(Zc, ui, A2(Zc, ui, lc(ui)))), A2(vc, ji(A3(Yi, 0, 28, 0)), A2(vc, function(n) {
        return A2(Ac, Wc(A3(Yi, 30, 30, 30)), n);
    }, ei(mo(v([
        ii,
        oi
    ])))))), rf = So(mo(v([
        Hc,
        nf,
        Xc
    ]))), ef = {
        cb: !0,
        ci: !1
    }, tf = F2(function(n, r) {
        return A2(Go, n, {
            $: 3,
            a: r
        });
    }), uf = F6(function(n, r, e, t, u, a) {
        return {
            dz: r,
            cv: e,
            d$: n,
            c_: t,
            ez: u,
            eY: a
        };
    }), af = A2(it, function(n) {
        switch(n){
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 3;
            case 3:
                return 4;
            case 4:
                return 5;
            default:
                return 0;
        }
    }, A2(kt, "button", Ct)), of = A3(ot, F2(function(n, r) {
        return i(n, r);
    }), A2(kt, "clientX", Uu), A2(kt, "clientY", Uu)), cf = L, ff = A4($o, F3(function(n, r, e) {
        return {
            du: n,
            dH: r,
            e0: e
        };
    }), A2(kt, "altKey", cf), A2(kt, "ctrlKey", cf), A2(kt, "shiftKey", cf)), sf = V, bf = A3(ot, F2(function(n, r) {
        return i(n, r);
    }), A2(kt, "offsetX", Uu), A2(kt, "offsetY", Uu)), lf = A3(ot, F2(function(n, r) {
        return i(n, r);
    }), A2(kt, "pageX", Uu), A2(kt, "pageY", Uu)), vf = A3(ot, F2(function(n, r) {
        return i(n, r);
    }), A2(kt, "screenX", Uu), A2(kt, "screenY", Uu)), df = A7(sf, uf, ff, af, of, bf, lf, vf), gf = F3(function(n, r, e) {
        return A2(tf, n, A2(it, function(n) {
            return {
                ek: e(n),
                cb: r.cb,
                ci: r.ci
            };
        }, df));
    }), hf = A2(gf, "mousedown", ef), mf = {
        cb: !0,
        ci: !1
    }, pf = F4(function(n, r, e, t) {
        return {
            dD: r,
            d$: n,
            e6: e,
            dn: t
        };
    }), $f = j, Af = A5($f, F4(function(n, r, e, t) {
        return {
            cv: r,
            dX: n,
            ez: e,
            eY: t
        };
    }), A2(kt, "identifier", Ct), of, lf, vf), Tf = A2(gt, ot(we), ct(s)), Ef = I, yf = function(n) {
        var r = function(r) {
            return A2(kt, Me(r), n);
        };
        return A2(Ef, function(n) {
            return Tf(A2(ht, r, A2(Be, 0, n - 1)));
        }, A2(kt, "length", Ct));
    }, wf = A5($f, pf, ff, A2(kt, "changedTouches", yf(Af)), A2(kt, "targetTouches", yf(Af)), A2(kt, "touches", yf(Af))), _f = F3(function(n, r, e) {
        return A2(tf, n, A2(it, function(n) {
            return {
                ek: e(n),
                cb: r.cb,
                ci: r.ci
            };
        }, wf));
    }), Ff = A2(_f, "touchend", mf), Sf = A2(gf, "mousemove", ef), Rf = A2(_f, "touchmove", mf), Lf = A2(_f, "touchstart", mf), Df = A2(gf, "mouseup", ef), Nf = {
        $: 7
    }, Of = F, kf = So(A2(Zc, ci = A2(Qi, 1 / 255, A3(Yi, 237, 212, 0)), A2(Zc, ci, lc(ci)))), Cf = F6(function(n, r, e, t, u, a) {
        return c(A6(wc, n, r, e, t, u, a), {
            eX: A2(Fc, A3(Yi, 200, 200, 200), gc)
        });
    }), Mf = {
        src: "\n     attribute vec3 position;\n     attribute vec3 color;\n     uniform mat4 perspective;\n     uniform mat4 camera;\n     uniform mat4 preScale;\n     uniform mat4 preRotation;\n     uniform mat4 preTranslation;\n     uniform mat4 scale;\n     uniform mat4 rotation;\n     uniform mat4 translation;\n     uniform mat4 postScale;\n     uniform mat4 postRotation;\n     uniform mat4 postTranslation;\n     varying vec3 vcolor;\n     void main () {\n       gl_Position = (perspective * camera * \n                      postTranslation * postRotation * postScale * \n                      translation * rotation * scale *\n                      preTranslation * preRotation * preScale * vec4(position, 1.0));\n       vcolor = color;\n     }\n  ",
        attributes: {
            color: "dE",
            position: "aD"
        },
        uniforms: {
            camera: "dA",
            perspective: "eA",
            postRotation: "eF",
            postScale: "eG",
            postTranslation: "eH",
            preRotation: "eJ",
            preScale: "eK",
            preTranslation: "eL",
            rotation: "eT",
            scale: "eX",
            translation: "fb"
        }
    }, If = {
        src: "\n     attribute vec3 position;\n     attribute vec3 color;\n     uniform mat4 perspective;\n     uniform mat4 camera;\n     uniform mat4 preScale;\n     uniform mat4 preRotation;\n     uniform mat4 preTranslation;\n     uniform mat4 scale;\n     uniform mat4 rotation;\n     uniform mat4 translation;\n     uniform mat4 postScale;\n     uniform mat4 postRotation;\n     uniform mat4 postTranslation;\n     varying vec3 vcolor;\n     void main () {\n       gl_Position = (perspective * camera * \n                      postTranslation * postRotation * postScale * \n                      translation * rotation * scale *\n                      preTranslation * preRotation * preScale * vec4(position, 1.0));\n       vcolor = color;\n     }\n  ",
        attributes: {
            color: "dE",
            position: "aD"
        },
        uniforms: {
            camera: "dA",
            perspective: "eA",
            postRotation: "eF",
            postScale: "eG",
            postTranslation: "eH",
            preRotation: "eJ",
            preScale: "eK",
            preTranslation: "eL",
            rotation: "eT",
            scale: "eX",
            translation: "fb"
        }
    }, Pf = F5(function(n, r, e, t) {
        var u, a, i, o = e.eR, c = e.ey, f = t.dV, b = Pc(v([
            Ic,
            Mc(1029)
        ])), l = n.dO, d = t.dN, g = t.t, h = c ? v([
            xo("background-black")
        ]) : s, m = e.dB, p = t.dA;
        return A4(Wo, h, v([
            Uc(o),
            (u = c, i = u ? "overview-toggle-on" : "overview-toggle-off", A2(jo, v([
                Uo("overview-toggle-overlay"),
                xo(A2(Of, i, " noselect")),
                (a = Nf, A2(Xo, "mousedown", ct(a)))
            ]), v([
                A2(jo, s, v([
                    tc("Overview")
                ]))
            ]))),
            A2(jo, v([
                Uo("debug-overlay"),
                xo("noselect")
            ]), v([
                A2(jo, s, v([
                    tc("")
                ]))
            ]))
        ]), v([
            Ff(A2(Pt, cc, bc)),
            Lf(A2(Pt, cc, fc)),
            Rf(A2(Pt, cc, sc)),
            Df(A2(Pt, cc, oc)),
            hf(A2(Pt, cc, ac)),
            Sf(A2(Pt, cc, ic))
        ]), v([
            A4(b, If, Yc, rf, A6(xc, c, 100, m, d, f, p)),
            A4(b, If, Yc, Bc, A6(jc, c, 100, m, d, f, p)),
            A4(b, If, Yc, l, A6(Rc, c, 1e3, m, d, f, p)),
            A4(b, If, Yc, dc, A6(Lc, c, 1e4, m, d, f, p)),
            A4(b, If, Yc, kf, A6(Cf, c, 1e4, m, d, f, p)),
            A4(b, Mf, zc, Oc, A2(Cc, m, g.dq ? 1 : .5)),
            A4(b, Mf, zc, Nc, A2(Cc, m, g.cA ? 1 : .5))
        ]));
    }), Bf = A4(Wo, s, v([
        A2(jo, v([
            xo("game-loader-container")
        ]), v([
            A2(rc, s, v([
                tc("Loading game..")
            ]))
        ]))
    ]), s, s), xf = {
        $: 2
    };
    fi = {
        Main: {
            init: Rt({
                dZ: function(n) {
                    var r = A2(Ot, Mt, n);
                    if (1 === r.$) return i(Nt("Could not read environment variables"), zt);
                    var e = function(n) {
                        return i({
                            bR: {
                                aY: 0,
                                bC: s,
                                e_: n.e_
                            }
                        }, A2(xt, It, jt("webgl-canvas")));
                    }(r.a), t = e.b;
                    return i(Lt(e.a.bR), A2(Vt, Dt, t));
                },
                e5: function(n) {
                    switch(n.$){
                        case 0:
                            return A2(Ht, Dt, ba);
                        case 2:
                            return A2(Ht, Wt, va);
                        case 1:
                            return A2(Ht, Yt, _u);
                        case 3:
                            return A2(Ht, Kt, Wu);
                        case 4:
                            return A2(Ht, qt, Ku);
                        default:
                            return Xt;
                    }
                },
                fc: Oo,
                fd: function(n) {
                    switch(n.$){
                        case 5:
                            return A2(jo, s, v([
                                tc(n.a)
                            ]));
                        case 0:
                            return A2(ko, Dt, (e = n.a, A4(Wo, s, v([
                                A2(jo, v([
                                    xo("initialization-container")
                                ]), v([
                                    A2(rc, s, v([
                                        tc(A2(Of, "Loading assets.. ", Me(e.aY)))
                                    ]))
                                ]))
                            ]), s, s)));
                        case 2:
                            return A2(ko, Wt, (r = n.b, A4(Wo, s, v([
                                A2(jo, v([
                                    xo("main-menu-container")
                                ]), v([
                                    A2(rc, s, v([
                                        tc("So it begins (the grand hot air balloon adventure)")
                                    ])),
                                    A2(rc, s, v([
                                        tc(A2(Of, "Welcome ", r.es))
                                    ])),
                                    A2(Io, v([
                                        Jo(xf)
                                    ]), v([
                                        tc("Start here")
                                    ]))
                                ]))
                            ]), s, s)));
                        case 1:
                            return A2(ko, Yt, function(n) {
                                var r;
                                return A4(Wo, s, v([
                                    A2(jo, v([
                                        xo("gather-info-container")
                                    ]), v([
                                        A2(rc, s, v([
                                            tc("So it begins (the grand hot air balloon adventure)")
                                        ])),
                                        A2(Ho, v([
                                            ec("Please write your name here.."),
                                            uc(n.es),
                                            (r = Mo, A2(Zo, "input", A2(it, Qo, A2(it, r, nc))))
                                        ]), s),
                                        A2(Io, v([
                                            Jo(Co)
                                        ]), v([
                                            tc("And continue!")
                                        ]))
                                    ]))
                                ]), s, s);
                            }(n.b));
                        case 3:
                            return A2(ko, Kt, Bf);
                        default:
                            return A2(ko, qt, A5(Pf, n.a, n.b, n.d, n.e, n.c));
                    }
                    var r, e;
                }
            })(fa)(0)
        }
    }, n.Elm ? function n(r, e) {
        for(var t in e)t in r ? "init" == t ? m(6) : n(r[t], e[t]) : r[t] = e[t];
    }(n.Elm, fi) : n.Elm = fi;
}($a0b4f895e1596b3b$exports);



const $dad545c909cfec2d$var$runtimeServerUpdateInterval = "%%RUNTIME_SERVER_UPDATE_INTERVAL%%";
const $dad545c909cfec2d$var$runtimeServerApi = "%%RUNTIME_SERVER_API%%";
const $dad545c909cfec2d$var$serverUpdateInterval = parseInt(!$dad545c909cfec2d$var$runtimeServerUpdateInterval.includes("RUNTIME_SERVER_UPDATE_INTERVAL") ? $dad545c909cfec2d$var$runtimeServerUpdateInterval : "1000");
const $dad545c909cfec2d$var$serverApi = !$dad545c909cfec2d$var$runtimeServerApi.includes("RUNTIME_SERVER_API") ? $dad545c909cfec2d$var$runtimeServerApi : "ws://localhost:8765";
const $dad545c909cfec2d$var$flags = {
    "serverUpdateInterval": $dad545c909cfec2d$var$serverUpdateInterval
};
// Start the Elm application.
const $dad545c909cfec2d$var$app = (0, $a0b4f895e1596b3b$exports.Elm).Main.init({
    node: document.getElementById('root'),
    flags: $dad545c909cfec2d$var$flags
});
var $3e20ba85543bf137$exports = {};
var $56b621a6dd25b2cb$exports = {};
"use strict";
$56b621a6dd25b2cb$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? 'import ' + JSON.stringify(workerUrl) + ';' : 'importScripts(' + JSON.stringify(workerUrl) + ');';
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: 'application/javascript'
        }));
    }
};


let $3e20ba85543bf137$var$url = new URL(import.meta.resolve("kuAly"));
$3e20ba85543bf137$exports = $56b621a6dd25b2cb$exports($3e20ba85543bf137$var$url.toString(), $3e20ba85543bf137$var$url.origin, true);


// Generate earth mesh from cubemap textures using web worker
const $dad545c909cfec2d$var$meshWorker = new Worker($3e20ba85543bf137$exports);
const $dad545c909cfec2d$var$nParts = 4;
const $dad545c909cfec2d$var$subdivisions = 5; // 20,480 triangles — good balance of detail and performance
$dad545c909cfec2d$var$meshWorker.postMessage({
    cubemapBaseUrl: "",
    subdivisions: $dad545c909cfec2d$var$subdivisions,
    nParts: $dad545c909cfec2d$var$nParts
});
$dad545c909cfec2d$var$meshWorker.addEventListener("message", function(event) {
    console.log("Main: Got mesh from worker!");
    async function sendData() {
        for(let i = 0; i < $dad545c909cfec2d$var$nParts; i++){
            const data = {
                "data": event.data[i],
                "totalAmount": $dad545c909cfec2d$var$nParts,
                "index": i
            };
            console.log("Sending part " + i.toString() + " to elm.");
            $dad545c909cfec2d$var$app.ports.objReceiver.send(data);
            console.log("Sleeping for a while..");
            await new Promise((r)=>setTimeout(r, 1000));
        }
    }
    sendData();
});
// To decouple player logic from world logic,
// we update the world parameters here outside of elm realm.
const $dad545c909cfec2d$var$socket = new WebSocket($dad545c909cfec2d$var$serverApi);
$dad545c909cfec2d$var$socket.addEventListener('message', function(event) {
    const data = JSON.parse(event.data);
    $dad545c909cfec2d$var$app.ports.messageReceiver.send(JSON.stringify(data));
});
$dad545c909cfec2d$var$socket.addEventListener('error', function(event) {
    const data = {
        "status": "fail"
    };
    $dad545c909cfec2d$var$app.ports.messageReceiver.send(JSON.stringify(data));
    $dad545c909cfec2d$var$socket.close();
});
function $dad545c909cfec2d$var$myCallback() {
    if ($dad545c909cfec2d$var$socket.readyState !== WebSocket.CLOSED) $dad545c909cfec2d$var$socket.send('{}');
}
const $dad545c909cfec2d$var$intervalID = window.setInterval($dad545c909cfec2d$var$myCallback, $dad545c909cfec2d$var$serverUpdateInterval);


//# sourceMappingURL=app.9e8e3b91.js.map
